import React, { useState, useEffect, useContext, useRef, ChangeEvent, FormEvent, useMemo, useState as useStateDefault, useCallback } from 'react';
import { Row, Col, Table, Form, Container, Card, ListGroup, Dropdown, Button, Tooltip, OverlayTrigger, Nav, Tab, InputGroup, Popover, NavDropdown, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faTrash  } from '@fortawesome/pro-regular-svg-icons';
import Select from 'react-select'
import { toast } from 'react-toastify';
import { SubmitHandler, useForm, FormProvider } from 'react-hook-form';

import AccountInformation from '../../pages/account/Settings/AccountInformation';

import { 
  genericUserIcon,
  deleteIcon,
  closeBtn,
} from './../../assets/images';

import {
  imageMap,
} from '../../pages/generic/Dashboard/data';

import { 
  DEFAULT_API_RESULT
} from '../../utilities/variables';

import {
  variables,
  helpers,
  types,
  api,
  authContextHelper
} from 'utilities';

import {ConfirmReleaseModal} from '../modals'
import { AiOutlineUserAdd } from 'react-icons/ai';
import { ColDef, ICellRendererParams, RowClassParams } from 'ag-grid-community';

import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'; 
ModuleRegistry.registerModules([AllCommunityModule]);
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component


const AdminGroupsContentEditFormPane: React.FunctionComponent<any> = (props: any) => {
  const [editFormBody, setEditFormBody] = useState<any>({});
  const [isGroupNameValid, setGroupNameValid] = useState(true);
  const [isGroupDescriptionValid, setGroupDescriptionValid] = useState(true);
  const [groupUsers, setGroupUsers] = useState<any>([]);
  const [userList, setUserList] = useState<types.IUserListAttributes[]>([]); 
  const [groupOwner, setGroupOwner] = useState<string>('');

  const [isFormChanged, setFormChanged] = useState(false);

  const [containerHeight, setContainerHeight] = useState<number>(400); // Default height
  
  const { 
    groupContent, 
    users, 
    editGroupSubmitError,
    handleGroupEditSubmit,
    mediaControlHandlers
  } = props;



  const mapUserIdsToUsers = useCallback((userIds: string[]) => {
    return userIds
      ?.map((userId) => {
        const user = userList.find((user) => user.id === userId);
        if (user) {
          return {
            label: user.display_name,
            sub_label: user.name.first,
            value: userId,
          };
        }
        return null;
      })
      .filter(Boolean); // Remove any nulls
  }, [userList]);

  const mapUserIdToDisplayName = useCallback((id: string): string => {
    const foundUser = userList.find(user => user.id === id);
  
    if (foundUser?.display_name) {
      return foundUser.display_name;
    }
  
    return 'Displayname Not Found';
  }, [userList]);

  useEffect(() => {
    setFormChanged(false);
    setEditFormBody({...groupContent});
    setGroupNameValid(true);
    setGroupDescriptionValid(true);

    
    if (groupContent && groupContent.users) {
      setGroupUsers(mapUserIdsToUsers(groupContent.users));
    } else {
      setGroupUsers([])
    }
    
  }, [groupContent, mapUserIdsToUsers]);

  useEffect(() => {
    setUserList(users)
  }, [users]);

  useEffect(() => {

    if (groupContent && groupContent.users) {
      setGroupUsers(mapUserIdsToUsers(groupContent.users));
    } else {
      setGroupUsers([])
    }

    if (groupContent && groupContent.owner) {
      setGroupOwner(mapUserIdToDisplayName(groupContent.owner))
    }
    
  }, [userList, groupContent, mapUserIdsToUsers, mapUserIdToDisplayName]);

  const handleInputChange = (event: any) => {
    // Toggle Form has Changed
    setFormChanged(true);

    //
    if(event.target.name === 'name') {
      // event.target.value = event.target.value.split(" ").join("");
      event.target.value = event.target.value.replace(' ', '');
      if (variables.DEFAULT_FORM_VALIDATION.GROUP.NAME.test(event.target.value)) {
        setGroupNameValid(true);
      } else {
        setGroupNameValid(false);
      }
    }

    if(event.target.name === 'description') {
      // event.target.value = event.target.value.split(" ").join("");
      // event.target.value = event.target.value.replace(" ", "");
      if (variables.DEFAULT_FORM_VALIDATION.GROUP.DESCRIPTION.test(event.target.value) || event.target.value === '') {
        setGroupDescriptionValid(true);
      } else {
        setGroupDescriptionValid(false);
      }
    }

    setEditFormBody({
      ...editFormBody,
      [event.target.name]: event.target.value,
    });

  }

  const addGroupUser = (event: any, userId: any, display_name: any, firstname: any) => {
    event.preventDefault();
    

    setGroupUsers([
      ...groupUsers,
      {
        label: display_name,
        sub_label: firstname,
        value: userId
      }
    ]);
    


    setFormChanged(true);
  }

  const removeGroupUser = (event: any, userId: number) => {
    event.preventDefault();
      
    setGroupUsers([...groupUsers.filter((user: any) => user !== userId)]);
    
    setFormChanged(true);
  }

  const validateForm = () => {
    
    return;
  }

  const handleFormSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    

    validateForm();

    if (isGroupNameValid && isGroupDescriptionValid){
      
      
      try {
        await handleGroupEditSubmit({
          body: {
            ...editFormBody,
            users: [...groupUsers]
          }
        });
      } catch (error) {
        helpers.logToOutput('Error while submitting the form', error);
      }
    } 
  }

  const Tip: React.FC<types.TipProps> = ({ id, children, title }) => (
    <div className='hover-content'>
      <OverlayTrigger overlay={<Tooltip id={id}>{title}</Tooltip>}>
        <a href="#">{children}</a>
      </OverlayTrigger>
    </div>
  );


  // Function to update the container height based on window size
  const updateHeight = () => {
    const windowHeight = window.innerHeight;
    const newHeight = windowHeight - 550; // Minus the top and bottom banners etc...
    setContainerHeight(newHeight);
  };

  useEffect(() => {
    updateHeight(); // Set initial height
    window.addEventListener('resize', updateHeight);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);

  const [showOverlay, setShowOverlay] = useStateDefault<boolean>(false);
  const [searchTerm, setSearchTerm] = useState('');
  const toggleOverlay = () => {
    setShowOverlay(!showOverlay);
  };

  const filteredUsers = users
    ? users.filter((user:any) =>
      user.display_name.toLowerCase().includes(searchTerm.toLowerCase())
    )
    : [];

  return (
    <>
      <Form onSubmit={handleFormSubmit} key={groupContent.id} className='m-2'>
        <Container className="" >
          <Row className="m-0">
            <Col className="col-9 pb-3">
              <Row className="m-0">
                <Col className="col-3 ps-0">
                  <span className='txt-10 color-lightHeader'>Group Name</span>
                  <Form.Group className="p-0 " controlId="paneGroupEditForm.Name">
                    <Form.Control className="p-0 k-inputText k-inputText15 k-bord-col-trans k-outline-none" type="text" placeholder="Name" defaultValue={groupContent.name} name='name'  onChange={handleInputChange}/>
                  </Form.Group>
                  {isGroupNameValid ?  null: <small style={{color: 'red'}}>Enter a valid Group Name. {'(5 - 25 Alphanumeric only)'}</small>}
                </Col>
                <Col className="col-6 ps-0">
                  <span className='txt-10 color-lightHeader'>Description</span>
                  <Form.Group className="p-0 " controlId="paneGroupEditForm.Description">
                    <Form.Control className="p-0 k-inputText k-inputText15 k-bord-col-trans k-outline-none" type="text" placeholder="Description" defaultValue={groupContent.description} name='description' onChange={handleInputChange}/>
                  </Form.Group>
                  {isGroupDescriptionValid ?  null : <small style={{color: 'red'}}>Enter a valid Group Description. {'(Alphabets, Numbers, space and charcaters[-., ()/] accepted)'}</small>}
                </Col>
                <Col className="col-3 ps-0">
                  <span className='txt-10 color-lightHeader'>Owner</span>
                  <Form.Group className="p-0 " controlId="paneGroupEditForm.User">
                    <Form.Control disabled className="p-0 k-inputText k-inputText15 k-bord-col-trans k-outline-none" type="text" placeholder="Owner" defaultValue={groupOwner} name='owner'/>
                  </Form.Group>
                </Col>
              </Row>
            </Col>
            <Col className="col-3 p-0 pt-2">
              <Row className="d-flex justify-content-end">
                <div className="p-0 pt-2 d-flex justify-content-end">
                  <Button
                    variant="success"
                    type="submit"
                    disabled={!isGroupNameValid || !isGroupDescriptionValid || !isFormChanged}
                    size="sm"
                    className="k-btn"
                  >
                    Update
                  </Button>
                  <Button
                    variant="danger"
                    style={{ marginLeft: '1%' }}
                    type="button"
                    size="sm"
                    className="k-btn"
                    onClick={(event: any) => {
                      mediaControlHandlers.handleGroupsListDelete(event, {
                        id: groupContent.id,
                        name: groupContent.name,
                      });
                    }}
                  >
                    Remove
                  </Button>
                </div>
              </Row>
              <Row className="m-0 pb-3">
                {editGroupSubmitError ? (
                  <>
                    <small style={{ color: 'red' }}>{editGroupSubmitError}</small>
                  </>
                ) : null}
              </Row>
            </Col>
          </Row>
          <Row className="m-0">
            <Col className="col-6 pb-3">
              <Row className="m-0">
                <Col className='m-0 p-0 col-11'> <span className='txt-10 color-lightHeader ps-0'>Members </span> </Col>
                <Col className='m-0 p-0 col-1 k-center-content k-hover b-rad-5'>
                  <OverlayTrigger
                    show={showOverlay}
                    key={'oTrigKey-group'}
                    placement="right-start"
                    overlay={
                      <Popover id={'popover-positioned-oTrigKey-group'} className="k-z-ind-99999 k-no-pop-arrow ms-4 k-w-220">
                        <Popover.Header as="h3">
                          <Row>
                            <Col className="col-10 k-panel-cent-vert">Add User to Group</Col>
                            <Col className="col-2 k-panel-cent-vert k-center-content-hor-right">
                              <div>
                                <OverlayTrigger
                                  trigger="hover"
                                  placement="top"
                                  delay={{ show: 1000, hide: 200 }}
                                  overlay={
                                    <Popover id={'popover-m-groupuseradd'} className="k-z-ind-popup b-rad-10">
                                      <Popover.Body className="p-1 m-0 txt-weight-200 txt-12 text-center">
                                      Click to close the menu
                                      </Popover.Body>
                                    </Popover>
                                  }
                                >
                                  <img
                                    className="k-mh-20 k-opac-50pc k-pointer"
                                    onClick={toggleOverlay}
                                    src={closeBtn}
                                    alt="Close"
                                  />
                                </OverlayTrigger>
                              </div>
                            </Col>
                          </Row>
                        </Popover.Header>

                        <Popover.Body className="p-0">
                          <Nav className="pb-2">

                            <Form.Control
                              type="text"
                              placeholder="Search users..."
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                              className="m-2"
                            />

                            {filteredUsers.map((user: { id: any; display_name: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | (string & React.ReactElement<any, string | React.JSXElementConstructor<any>>) | (string & Iterable<React.ReactNode>) | (string & React.ReactPortal) | (number & React.ReactElement<any, string | React.JSXElementConstructor<any>>) | (number & Iterable<React.ReactNode>) | (number & React.ReactPortal) | (false & React.ReactElement<any, string | React.JSXElementConstructor<any>>) | (false & Iterable<React.ReactNode>) | (false & React.ReactPortal) | (true & React.ReactElement<any, string | React.JSXElementConstructor<any>>) | (true & Iterable<React.ReactNode>) | (true & React.ReactPortal) | (React.ReactElement<any, string | React.JSXElementConstructor<any>> & string) | (React.ReactElement<any, string | React.JSXElementConstructor<any>> & number) | (React.ReactElement<any, string | React.JSXElementConstructor<any>> & false) | (React.ReactElement<any, string | React.JSXElementConstructor<any>> & true) | (React.ReactElement<any, string | React.JSXElementConstructor<any>> & Iterable<React.ReactNode>) | (React.ReactElement<any, string | React.JSXElementConstructor<any>> & React.ReactPortal) | (Iterable<React.ReactNode> & string) | (Iterable<React.ReactNode> & number) | (Iterable<React.ReactNode> & false) | (Iterable<React.ReactNode> & true) | (Iterable<React.ReactNode> & React.ReactElement<any, string | React.JSXElementConstructor<any>>) | (Iterable<React.ReactNode> & React.ReactPortal) | (React.ReactPortal & string) | (React.ReactPortal & number) | (React.ReactPortal & false) | (React.ReactPortal & true) | (React.ReactPortal & React.ReactElement<any, string | React.JSXElementConstructor<any>>) | (React.ReactPortal & Iterable<React.ReactNode>) | (Iterable<React.ReactNode> & string) | (Iterable<React.ReactNode> & number) | (Iterable<React.ReactNode> & false) | (Iterable<React.ReactNode> & true) | (Iterable<React.ReactNode> & React.ReactElement<any, string | React.JSXElementConstructor<any>>) | (Iterable<React.ReactNode> & Iterable<React.ReactNode>) | (Iterable<React.ReactNode> & React.ReactPortal); name: { first: any; }; }, index: any) => {
                              const isUserInGroup = groupUsers?.some(
                                (groupUser: { value: any; }) => groupUser.value === user.id
                              );

                              // If user is already in the group, don't show them
                              if (isUserInGroup) {
                                return null;
                              }

                              return (
                                <NavDropdown.Item
                                  className="k-inputText12 p-2 mx-2 k-hover"
                                  key={`paneGroupEditForm.Dropdown.${index}`}
                                  onClick={(event) =>
                                    addGroupUser(
                                      event,
                                      user.id,
                                      user.display_name,
                                      user.name.first
                                    )
                                  }
                                >
                                  {user.display_name}
                                </NavDropdown.Item>
                              );
                            })}
                          </Nav>
                        </Popover.Body>
                      </Popover>
                    }
                  >
                    <Button
                      variant="link"
                      onClick={toggleOverlay}
                      className="k-bg-trans m-0 p-0 k-border-none k-center-content-hor-right  "
                    >
                      <AiOutlineUserAdd />
                    </Button>
                  </OverlayTrigger>
                </Col>
                <hr className="k-border-top-black mt-1 mb-1"></hr>
              </Row>
              <Row>
                <Col className='k-overflow-y-scroll-x-hide-nobars'>
                  {groupUsers && groupUsers.map((user: any, index: number) => (
                    <Row className="m-0 p-0 k-hover-element" key={`paneGroupEditForm.Users.${index}`}>
                      <Col className="col-12 k-inputText k-inputText15-light ps-0 pe-0">
                        <Row className='m-0 mb-2 p-0'>
                          <Col className='col-2 p-0'><img className="k-ctrlImgLrg" src={genericUserIcon}/></Col>
                          <Col className='col-9 p-0 m-0'>
                            <Row className='m-0 p-0 k-mb-m-4'>
                              <Col className='m-0 p-0'>{user.label}</Col>
                            </Row>
                            <Row className='m-0 p-0'>
                              <Col className=' p-0 txt-13 txt-light '>{user.sub_label} </Col>
                            </Row>
                          </Col>
                          <Col className='col-1 p-0 mt-1 mb-1 k-center-content k-hover b-rad-5'>
                            <Tip id="t-1" title="Remove a user">
                              <img className="k-ctrlImgSml" src={deleteIcon} style={{ cursor: 'pointer'}} onClick={(event: any) => removeGroupUser(event, user)}/>
                            </Tip>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  ))}
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </Form>
    </>
  );
}

const AdminUsersContentEditFormPane: React.FunctionComponent<any> = (props: any) => {
  const [editFormBody, setEditFormBody] = useState<any>({});
  const [isDisplayNameValid, setDisplayNameValid] = useState(true);
  const [isRoleValid, setRoleValid] = useState(true);
  const [userGroupIds, setUserGroupIds] = useState<any>([]);
  const [_securityGroups, setSecurityGroups] = useState<any>([]);

  const [_isPhoneValid, setPhoneValid] = useState(true);
  const [isNameFieldsValid, setNameFieldsValid] = useState(true);
  const [isIdentifierValid, setIdentifierValid] = useState(true);
  const [isEmailValid, setEmailValid] = useState(true);
  const [isPasswordValid, setPasswordValid] = useState(true);
  
  const [isFormChanged, setFormChanged] = useState(false);
  
  const { 
    userContent, 
    groups, 
    editUserSubmitError,
    handleUserEditSubmit,
    mediaControlHandlers
  } = props;



  useEffect(() => {
    setFormChanged(false);
    setEditFormBody({...userContent});
    setDisplayNameValid(true);
    setRoleValid(true);
    setPasswordValid(true);
    // setGroupDescriptionValid(true);
    setSecurityGroups(groups)
    setUserGroupIds((userContent && userContent.security) || []);
  }, [groups, userContent]);

  const handleInputChange = (event: any) => {
    // Toggle Form has Changed
    setFormChanged(true);

    if(variables.DEFAULT_FORM_NAME_FIELDS.includes(event.target.name)) {
      // event.target.value = event.target.value.split(" ").join("");
      //event.target.value = event.target.value.replace(' ', '');
      if (variables.DEFAULT_FORM_VALIDATION.USER.NAME.test(event.target.value) || event.target.value === '') {
        setNameFieldsValid(true);
      } else {
        setNameFieldsValid(false);
      }
    }
    
    if(event.target.name === 'identifier') {
      // event.target.value = event.target.value.split(" ").join("");
      event.target.value = event.target.value.replace(' ', '');
      if (variables.DEFAULT_FORM_VALIDATION.USER.EMAIL.test(event.target.value)) {
        setIdentifierValid(true);
      } else {
        setIdentifierValid(false);
      }
    }

    if(event.target.name === 'email') {
      // event.target.value = event.target.value.split(" ").join("");
      event.target.value = event.target.value.replace(' ', '');
      if (variables.DEFAULT_FORM_VALIDATION.USER.EMAIL.test(event.target.value)) {
        setEmailValid(true);
      } else {
        setEmailValid(false);
      }
    }

    if(event.target.name === 'display_name') {
      // event.target.value = event.target.value.split(" ").join("");
      //event.target.value = event.target.value.replace(' ', '');
      if (variables.DEFAULT_FORM_VALIDATION.USER.DISPLAY_NAME.test(event.target.value) || event.target.value === '') {
        setDisplayNameValid(true);
      } else {
        setDisplayNameValid(false);
      }
    }

    if(event.target.name === 'phone') {
      // event.target.value = event.target.value.split(" ").join("");
      event.target.value = event.target.value.replace(' ', '');
      if (variables.DEFAULT_FORM_VALIDATION.USER.PHONE_NUMBER.test(event.target.value) || event.target.value === '') {
        setPhoneValid(true);
      } else {
        setPhoneValid(false);
      }
    }

    if(event.target.name === 'password') {
      // event.target.value = event.target.value.split(" ").join("");
      //event.target.value = event.target.value.replace(' ', '');
      if (variables.DEFAULT_FORM_VALIDATION.USER.PASSWORD.test(event.target.value) || event.target.value === '') {
        setPasswordValid(true);
      } else {
        setPasswordValid(false);
      }
    }

    if(event.target.name === 'role') {
      if ( event.target.value !== '') {
        setRoleValid(true);
      } else {
        setRoleValid(false);
      }
    }

    setEditFormBody({
      ...editFormBody,
      [event.target.name]: event.target.value,
    });

  }

  const _addUserGroup = (event: any, groupId: any) => {
    event.preventDefault();

    setUserGroupIds([
      ...userGroupIds,
      groupId
    ]);

    setFormChanged(true);
  }

  const _removeUserGroup = (event: any, groupId: number) => {
    event.preventDefault();
      
    setUserGroupIds([...userGroupIds.filter((group: any) => group !== groupId)]);
    
    setFormChanged(true);
  }

  const validateForm = () => {
    return;
  }

  const handleFormSubmit = async(event: any) => {
    event.preventDefault();

    validateForm();

    if (isDisplayNameValid && isIdentifierValid && isRoleValid && isEmailValid ){
      const submitBody = {
        id: userContent.id,
        password: editFormBody['password'],
        name: {
          last:   editFormBody['lastName']   || userContent['name']['last']   || '',
          first:  editFormBody['firstName']  || userContent['name']['first']  || '',
          middle: editFormBody['middleName'] || userContent['name']['middle'] || '',
        },
        display_name: editFormBody['display_name'] ?? userContent['display_name'],
        identifier:   editFormBody['identifier']?.toLowerCase() ?? userContent['identifier'],
        email: editFormBody['email']?.toLowerCase() ?? userContent['email'],
        phone:        editFormBody['phone']       ?? userContent['phone'],
        role:         editFormBody['role']        ?? userContent['role'],
        enabled: (() => {
          if (typeof editFormBody.enabled === 'string')
            return editFormBody.enabled.toLowerCase() === 'true'; // 'true' → true, anything else → false
          if (typeof editFormBody.enabled === 'boolean')
            return editFormBody.enabled;                          // already a boolean
          return userContent.enabled;                             // untouched → keep existing value
        })(),
        mfa:          editFormBody['mfa']        ?? userContent['mfa'],
        auth_method:  editFormBody['authMethod'] ?? userContent['auth_method'],
        profile_photo: { avatar: 'default' }, // keep user’s photo for now
        limits: {
          android: editFormBody['android_limit'] ?? userContent['limits']['android'],
          vm: editFormBody['desktop_limit'] ?? userContent['limits']['vm'] ?? userContent['limits']['vm'],
        }
      };


      // Only add password if it's not null
      if (editFormBody['password'] !== null && isPasswordValid) {
        submitBody.password = editFormBody['password'];
      }

      await handleUserEditSubmit({
        body: {
          ...submitBody
        }
      });

      setFormChanged(false)

    } 
  }

  return (
    <>
      <Form onSubmit={handleFormSubmit} key={userContent?.id ?? 'default'} className='m-2'>
        <Container className="p-0 k-hmh-600px k-overflow-y-scroll-x-hide-nobars">

          <Row className="m-0 ps-1">
            <Col className="col-8 p-0">
              <Row className="m-0">
                <Col className="col-12 p-0">
                  <span className="txt-17">{userContent?.identifier ?? ''}</span>
                </Col>
              </Row>
              <Row className="m-0">
                <Col className="col-12 p-0">
                  <span className="txt-10 color-lighterText">{userContent?.id ?? ''}</span>
                </Col>
              </Row>
            </Col>

            {/* 👉 make this flex and justify to the end */}
            <Col className="col-4 p-0 pe-2 d-flex justify-content-end">
              <Button
                variant="success"
                type="submit"
                disabled={!isDisplayNameValid || !isRoleValid || !isIdentifierValid || !isFormChanged || !isEmailValid}
                size="sm"
                className="k-btn k-h-40 me-2"
              >
                Update
              </Button>

              <Button
                variant="danger"
                style={{ marginLeft: '1%' }}
                type="button"
                size="sm"
                className="k-btn k-h-40"
                onClick={(event: any) =>
                  mediaControlHandlers.handleUsersListDelete(event, {
                    id: userContent.id,
                    name: userContent['name']['first'] || userContent['display_name'],
                  })
                }
              >
                Remove
              </Button>
            </Col>
          </Row>


          <Row className="m-0 pb-3">
            <Col className="col-12">
              {editUserSubmitError? (<>
                <small style={{color: 'red'}}>{editUserSubmitError}</small>
              </>): null}
            </Col>
          </Row>
          
          <Row className='m-0 p-0 mt-3'>
            <Col className='m-0 p-0 col-12 pt-2 k-bg-menu-background b-rad-5'>
              <Row className="ms-0 "><Col className="col-12"><span className='txt-15'>General</span></Col></Row>
              <Row className="m-0"><Col className='col-12'><div className='k-border-top-lightgrey k-max-w-100pc'></div></Col></Row>
              <Row className="m-0"><Col className='col-12 pb-3'><div className='txt-10 color-lighterText'>General settings for your user</div></Col></Row>

              <Row className="m-0">
                <Col className="col-12 pb-4">
                  <Row className="m-0">
                    <Col className="col-4 ps-0">
                      <span className='txt-10 color-lightHeader'>Full Name</span>
                      <Form.Group className="p-0 " controlId="paneGroupEditForm.FullName">
                        <Form.Control
                          className="p-1 k-inputText txt-15 k-bord-col-trans k-outline-none k-bg-menu-background"
                          type="text"
                          placeholder="First Name"
                          defaultValue={userContent?.name?.first ?? ''}
                          name="firstName"
                          onChange={handleInputChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col className="col-4 ps-0">
                      <span className='txt-10 color-lightHeader'>Display Name</span>
                      <Form.Group className="p-0" controlId="paneGroupEditForm.Displayname">
                        <Form.Control
                          className="p-1 k-inputText txt-15 k-bord-col-trans k-outline-none k-bg-menu-background"
                          type="text"
                          placeholder="Display Name"
                          defaultValue={userContent?.display_name ?? ''}
                          name="display_name"
                          onChange={handleInputChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col className="col-4 ps-0">
                      <span className='txt-10 color-lightHeader'>Contact eMail</span>
                      <Form.Group className="p-0" controlId="paneGroupEditForm.eMail">
                        <Form.Control
                          className="p-1 k-inputText txt-15 k-bord-col-trans k-outline-none k-bg-menu-background"
                          type="email"
                          placeholder="Enter an email address"
                          defaultValue={userContent?.email ?? ''}
                          onChange={handleInputChange}
                          name="email"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="m-0">
                    <Col className="col-11 p-0">
                      {isNameFieldsValid ?  null: <small style={{color: 'red'}}>Enter a valid User Name(s), lowercase {'(1 - 25 Alphanumeric only)'}</small>}
                      {isDisplayNameValid ?  null: <small style={{color: 'red'}}>Enter a valid Display Name. {'(1 - 25 Alphanumeric only)'}</small>}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className='m-0 p-0 mt-2'>
            <Col className='m-0 p-0 col-12 pt-2  k-bg-menu-background b-rad-5'>
              <Row className="ms-0 "><Col className="col-12"><span className='txt-15'>User Permissions</span></Col></Row>
              <Row className="m-0"><Col className='col-12'><div className='k-border-top-lightgrey k-max-w-100pc'></div></Col></Row>
              <Row className="m-0"><Col className='col-12 pb-3'><div className='txt-10 color-lighterText'>Select the role for your user</div></Col></Row>

              <Row className="m-0">
                <Col className="col-4 pb-3">
                  <Row className="m-0">
                    <Col className="col-12 ps-0">
                      <span className='txt-10 color-lightHeader'>Role</span>
                      <Form.Group className="p-0 k-bord-col-trans k-outline-none" controlId="paneUserEditForm.Role">
                        <Form.Select
                          aria-label="Select a role"
                          className="p-0 k-inputSelect txt-15   k-bord-col-trans k-outline-none k-bg-menu-background"
                          name="role"
                          defaultValue={userContent?.role ?? ''}
                          onChange={handleInputChange}
                        >
                          <option value="user">User</option>
                          <option value="superuser">Super User</option>
                          <option value="administrator">Admin</option>
                          <option value="superadministrator">Super Admin</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
                <Col className="col-4 pb-3">
                  <Row className="m-0">
                    <Col className="col-12 ps-0">
                      <span className='txt-10 color-lightHeader'>Android Limit</span>
                      <Form.Group className="p-0" controlId="paneGroupEditForm.AndroidLimit">
                        <Form.Control
                          className="p-1 k-inputText txt-15 k-bord-col-trans k-outline-none k-bg-menu-background"
                          type="number"
                          defaultValue={userContent?.limits?.android ?? ''}
                          name="android_limit"
                          onChange={handleInputChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
                <Col className="col-4 pb-3">
                  <Row className="m-0">
                    <Col className="col-12 ps-0">
                      <span className='txt-10 color-lightHeader'>Desktop Limit</span>
                      <Form.Group className="p-0" controlId="paneGroupEditForm.DesktopLimit">
                        <Form.Control
                          className="p-1 k-inputText txt-15 k-bord-col-trans k-outline-none k-bg-menu-background"
                          type="number"
                          defaultValue={userContent?.limits?.vm ?? ''}
                          name="desktop_limit"
                          onChange={handleInputChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className='m-0 p-0 mt-3'>
            <Col className='m-0 p-0 col-12 pt-2 k-bg-menu-background b-rad-5'>
              <Row className="ms-0 "><Col className="col-12"><span className='txt-15'>Authentication and Access</span></Col></Row>
              <Row className="m-0"><Col className='col-12'><div className='k-border-top-lightgrey k-max-w-100pc'></div></Col></Row>
              <Row className="m-0"><Col className='col-12 pb-3'><div className='txt-10 color-lighterText'>Tailor authentication settings for your user</div></Col></Row>

              <Row className='m-0'>
                <Col className="col-12 pb-3">
                  <Row className="m-0">
                    <Col className="col-4 ps-0">
                      <span className='txt-10 color-lightHeader'>Authentication</span>
                      <Form.Group className="p-0 k-bord-col-trans k-outline-none" controlId="paneUserEditForm.auth_method">
                        <Form.Select
                          aria-label="Select Authentication"
                          className="p-1 k-inputSelect txt-15 k-bord-col-trans k-outline-none k-bg-menu-background"
                          name="authMethod"
                          defaultValue={userContent?.auth_method ?? ''}
                          onChange={handleInputChange}
                        >
                          <option value="EMAIL">Email</option>
                          <option value="PASSWORD_MFA">Password</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col className="col-4 ps-0">
                      <span className='txt-10 color-lightHeader'>MFA</span>
                      <Form.Group className="p-0 k-bord-col-trans k-outline-none" controlId="paneUserEditForm.Mfa">
                        <Form.Select
                          aria-label="Enable or Disable"
                          className="p-1 txt-15 k-bord-col-trans k-outline-none k-bg-menu-background color-lighterText"
                          name="mfa"
                          defaultValue={userContent?.mfa ?? ''}
                          onChange={handleInputChange}
                          disabled
                        >
                          <option value="mfaEnabled">Enable</option>
                          <option value="mfaDisabled">Disable</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col className="col-4 ps-0">
                      <span className='txt-10 color-lightHeader'>Password</span>
                      <Form.Group className="p-0 " controlId="paneGroupEditForm.Password">
                        <Form.Control className="p-1 k-bord-col-trans k-outline-none txt-15 k-bg-menu-background" type="password" placeholder="Change password" defaultValue='' autoComplete="current-password" name='password'  onChange={handleInputChange}/>
                      </Form.Group>
                    </Col>
                    
                  </Row>
                </Col>
              </Row>

              <Row className='m-0'>
                <Col className="col-12 pb-3">
                  <Row className='m-0'>
                    <Col className="col-4 ps-0">
                      <span className='txt-10 color-lightHeader'>Account Status</span>
                      <Form.Group className="p-0 k-bord-col-trans k-outline-none" controlId="paneUserEditForm.Enabled">
                        <Form.Select
                          aria-label="Enable or Disable"
                          className="p-1 k-inputSelect txt-15 k-bord-col-trans k-outline-none k-bg-menu-background"
                          name="enabled"
                          defaultValue={userContent?.enabled ?? ''}
                          onChange={handleInputChange}
                        >
                          <option value="true">Enabled</option>
                          <option value="false">Disabled</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>

        </Container>
      </Form>
    </>
  );
}

export const AdminUsersContentTab: React.FunctionComponent<any> = (props:any) => {
  const { 
    users,
    groups,
    selectedUser, 
    mediaControlHandlers,
    editUserSubmitError,
    handleUserEditSubmit,
    handleShowAddUserModal, 
    handleAdminSelectObject 
  } = props;

  const [containerHeight, setContainerHeight] = useState<number>(400); // Default height

  // Function to update the container height based on window size
  const updateHeight = () => {
    const windowHeight = window.innerHeight;
    const newHeight = windowHeight - 250; // Minus the top and bottom banners etc...
    setContainerHeight(newHeight);
  };

  useEffect(() => {
    updateHeight(); // Set initial height
    window.addEventListener('resize', updateHeight);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);


  useEffect(() => {
    if (!selectedUser.content && users && users.length > 0) {
      handleAdminSelectObject(null, { type: 'USER', id: users[0].id })
    }
  }, [users, selectedUser, handleAdminSelectObject]);
  

  return (
    <>
      <Row className=''>
        <Col className='col-12'>
          <Row className='m-0'>
            <Col className="">
              <Row className='m-0 p-0'><Col className='m-0 p-0'> <span className='txt-17'>User Administration</span></Col></Row>
              <Row className='m-0 p-0'><Col className='m-0 p-0'> <span className='txt-12'>Create, Edit and delete users for your organisation</span></Col></Row>
            </Col>
            <Col className="text-end k-center-content-hor-right-cen">
              <Button className="k-h-30 k-btn-submit-col txt-14 k-center-content" onClick={handleShowAddUserModal} type="submit">Add User</Button>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col className="col-3 p-0 ">
          <Row className="m-0 mt-2">
            <Col className="col-12">
              <div className="">
                <Row className='m-0 ps-2'>
                  <Table className='k-brd-transparent mb-0'>
                    <thead className=''>
                      <tr>
                        <th className='pb-1 ps-1 txt-12 color-lightText'>Users</th>
                      </tr>
                    </thead>
                    <div className="k-hmh-600px k-overflow-y-scroll-x-hide-nobars">
                      <tbody className='k-disp-inline-tbl k-wh-100pc'>
                        {users &&
                          [...users] // Create a shallow copy to avoid mutating the original array
                            .sort((a: any, b: any) => {
                              const nameA = a?.name?.first?.toLowerCase() || '';
                              const nameB = b?.name?.first?.toLowerCase() || '';
                              return nameA.localeCompare(nameB); // Compare strings alphabetically
                            })
                            .map((user: any, index: number) => {
                              return (
                                <tr className='k-bord-col-trans' key={`admin-users-${user.id}`}>
                                  <td key={`admin-users-td-${index}`} className='pt-1 pb-1' onClick={(event) => handleAdminSelectObject(event, { type: 'USER', id: user.id })}>
                                    <div
                                      className={(selectedUser?.content?.id === user.id) ? 'k-bg-selected-light b-rad-5 p-2' : 'k-hover p-2 b-rad-5'}
                                    >
                                      <Row><Col className='col-12'>{user?.name?.first || ''}</Col></Row>
                                      <Row><Col className='col-12 txt-12 color-lightText'>{user.identifier}</Col></Row>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                      </tbody>
                    </div>
                  </Table>
                </Row>
              </div>
            </Col>
          </Row>
        </Col>

        <Col className="col-9 p-0">
          <Row className="m-0 mt-2">
            <Col className="col-12">
              {(selectedUser && selectedUser.type === 'USER') ? (
                <>
                  <div className="minh-400">
                    <Row className='m-0 k-pt-8'>
                      <Col className='col-12'>
                        <span className='txt-12 color-lightHeader'>User Profile</span>
                        <hr className='k-border-top-black mt-1 mb-1'></hr>
                      </Col>
                    </Row>
                    <AdminUsersContentEditFormPane
                      userContent={selectedUser.content}
                      groups={groups}
                      editUserSubmitError={editUserSubmitError}
                      handleUserEditSubmit={handleUserEditSubmit}
                      mediaControlHandlers={mediaControlHandlers}
                    />
                  </div> 
                </>
              )
                :
                (<>
                  <div className="minh-400">
                    <Row className='m-0 pt-2'>
                      <Col className='col-12'>
                        <span className='txt-18'></span>
                      </Col>
                    </Row>
                  </div>
                </>
                )}
            </Col>
          </Row>
        </Col>

      </Row>
    </>

  );
}

export const AdminGroupsContentTab: React.FunctionComponent<any> = (props:any) => {
  const { 
    groups,
    users, 
    selectedGroup, 
    mediaControlHandlers,
    editGroupSubmitError,
    handleGroupEditSubmit,
    handleShowAddGroupModal, 
    handleAdminSelectObject 
  } = props;

  const [containerHeight, setContainerHeight] = useState<number>(400); // Default height

  // Function to update the container height based on window size
  const updateHeight = () => {
    const windowHeight = window.innerHeight;
    const newHeight = windowHeight - 250; // Minus the top and bottom banners etc...
    setContainerHeight(newHeight);
  };

  useEffect(() => {
    updateHeight(); // Set initial height
    window.addEventListener('resize', updateHeight);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);


  return (
    <>
      <Row className=''>
        <Col className='col-12'>
          <Row className='m-0'>
            <Col className="">
              <Row className='m-0 p-0'><Col className='m-0 p-0'> <span className='txt-17'>Group Administration</span></Col></Row>
              <Row className='m-0 p-0'><Col className='m-0 p-0'> <span className='txt-12'>Create, Edit and delete user groups for your organisation</span></Col></Row>
            </Col>
            <Col className="text-end k-center-content-hor-right-cen">
              <Button className="k-h-30 k-btn-submit-col txt-14 k-center-content" onClick={handleShowAddGroupModal} type="submit">Add Group</Button>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row >
        <Col className="col-3 p-0 ">
          <Row className="m-0 mt-2">
            <Col className="col-12">
              <div className="">
                <Row className='m-0 ps-2'>
                  <Table className='k-brd-transparent'>
                    <thead>
                      <tr>
                        <th className='pb-1 ps-1 txt-12 color-lightText'>Groups</th>
                      </tr>
                    </thead>
                    <div className="k-hmh-600px k-overflow-y-scroll-x-hide-nobars">
                      <tbody className='k-t-body-scroll-admin k-disp-inline-tbl k-wh-100pc'>
                        {groups &&
                          [...groups] // Create a shallow copy to avoid mutating the original array
                            .sort((a: any, b: any) => {
                              const nameA = a?.name?.toLowerCase() || '';
                              const nameB = b?.name?.toLowerCase() || '';
                              return nameA.localeCompare(nameB); // Compare strings alphabetically
                            })
                            .map((group: any, index: number) => {
                              return (
                                <tr className='k-bord-col-trans' key={`admin-users-${group.id}`}>
                                  <td
                                    key={`admin-users-${group.id}-${index}`}
                                    className='pt-1 pb-1'
                                    onClick={(event) => handleAdminSelectObject(event, { type: 'GROUP', id: group.id })}
                                  >
                                    <div
                                      className={(selectedGroup?.content?.id === group.id) ? 'k-bg-selected-light b-rad-5 p-2' : 'k-hover p-2 b-rad-5 k-wh-100pc'}
                                    >
                                      <Row><Col className='col-12'>{group.name}</Col></Row>
                                      <Row><Col className='col-12 txt-12 color-lightText'>{group.description}</Col></Row>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                      </tbody>
                    </div>
                  </Table>
                </Row>
              </div>
            </Col>
          </Row>
        </Col>

        <Col className="col-9 p-0">
          <Row className="m-0 mt-2">
            <Col className="col-12">
              {(selectedGroup && selectedGroup.type === 'GROUP') ? (
                <>
                  <div className="minh-400">
                    <Row className='m-0 k-pt-8'>
                      <Col className='col-12'>
                        <span className='txt-12 color-lightHeader'>Group Detail</span>
                        <hr className='k-border-top-black mt-1 mb-1'></hr>
                      </Col>
                    </Row>
                    <AdminGroupsContentEditFormPane
                      groupContent={selectedGroup.content}
                      users={users}
                      editGroupSubmitError={editGroupSubmitError}
                      handleGroupEditSubmit={handleGroupEditSubmit}
                      mediaControlHandlers={mediaControlHandlers}
                    />
                  </div> 
                </>
              )
                :
                (<>
                  <div className="minh-400">
                    <Row className='m-0 pt-2'>
                      <Col className='col-12'>
                        <span className='txt-18'></span>
                      </Col>
                    </Row>
                  </div>
                </>
                )}
            </Col>
          </Row>
        </Col>

      </Row>
    </>

  );
}

export const AdminProductContentTab: React.FunctionComponent<any> = (props:any) => {
  const { 
    users,
    products,
    selectedProduct,
    handleAdminSelectObject,
    getProductsCallback
  } = props;

  const [containerHeight, setContainerHeight] = useState<number>(250); // Default height
  
  
  useEffect(() => {
    helpers.logToOutput('AdminProductContentTab selectedProduct has changed: ', selectedProduct);
  },[selectedProduct]);


  const getUserNameById = (id: string): string | null => {
    const user = users.find((user: any) => user.id === id);
  
    if (user) {
      // If display_name is provided, return it, otherwise construct the name from first, middle, and last.
      return user.display_name || `${user.name.first} ${user.name.middle} ${user.name.last}`.trim();
    }
    
    return null; // Return null if no user is found
  };

  // Function to update the container height based on window size
  const updateHeight = () => {
    const windowHeight = window.innerHeight;
    const newHeight = windowHeight - 250; // Minus the top and bottom banners etc...
    setContainerHeight(newHeight);
  };

  useEffect(() => {
    updateHeight(); // Set initial height
    window.addEventListener('resize', updateHeight);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);



  return (
    <>
      <Row className=''>
        <Col className='col-12'>
          <Row className='m-0'>
            <Col className="">
              <Row className='m-0 p-0'><Col className='m-0 p-0'> <span className='txt-17'>Product Administration</span></Col></Row>
              <Row className='m-0 p-0'><Col className='m-0 p-0'> <span className='txt-12'>Administer desktops and servers for your organisation</span></Col></Row>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className='mt-2'>
        <Col className="col-3 p-0 ">
          <Row className="m-0">
            <Col className="col-12">
              <div className="">
                <Row className='m-0 ps-2'>
                  <Table className='k-brd-transparent'>
                    <thead className=''>
                      <tr>
                        <th className='pb-1 ps-1 txt-12 color-lightText'>Devices</th>
                      </tr>
                    </thead>
                    <div className="k-hmh-600px k-overflow-y-scroll-x-hide-nobars">
                      <tbody className='k-t-body-scroll-admin k-disp-inline-tbl k-wh-100pc'>
                        {products && products.map((product: any, index: number) => {
                          return (
                            <tr className='k-bord-col-trans' key={`admin-users-${product?.id ?? index}`}>
                              <td className='pt-1 pb-1' onClick={(event) => handleAdminSelectObject(event, { type: 'PRODUCT', id: product?.id ?? 'None' })}>
                                <div className={(selectedProduct?.content?.id === product?.id) ? 'k-bg-selected-light b-rad-5 p-2' : 'k-hover p-2 b-rad-5 k-wh-100pc'}>
                                  <Row>
                                    <Col className='col-2'>
                                      <img className='k-mh-30 mt-1' id={product?.parameters?.System ?? product?.product} src={imageMap[product?.parameters?.System] ?? imageMap[product?.product]} alt='Product Image' />
                                    </Col>
                                    <Col className='col-10'>
                                      <Row><Col className='col-12'>{product?.tags?.kname ?? 'None'}</Col></Row>
                                      <Row>
                                        <Col className='col-12 txt-12 color-lightText'>
                                          {getUserNameById(product?.user) ?? 'Unknown User'} / {(product?.provider ?? 'None').toUpperCase()} / {variables?.regionToLocationMap?.[product?.region] ?? 'None'}
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </div>
                  </Table>
                </Row>
              </div>
            </Col>
          </Row>
        </Col>

        <Col className="col-9 p-0">
          <Row className="m-0 mt-2">
            <Col className="col-12">
              {(selectedProduct && selectedProduct.type === 'PRODUCT') ? (
                <>
                  <Tab.Container id="profile-content-pane" defaultActiveKey="admin.ProductGeneral">
                    <Row id="k-adm-dash-l5" className='m-0 p-0 mt-1'>
                      <Nav className="pb-1">
                        <Nav.Item className="">
                          <Nav.Link eventKey="admin.ProductGeneral" className="p-0 txt-12">
                            General
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="ms-3">
                          <Nav.Link eventKey="admin.ProductStorage"  disabled className="p-0 txt-12 color-lightText">
                            Storage
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="ms-3">
                          <Nav.Link eventKey="admin.ProductMonitor"  disabled className="p-0 txt-12 color-lightText">
                            Monitor
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="ms-3">
                          <Nav.Link eventKey="admin.ProductLogs" disabled className="p-0 txt-12 color-lightText">
                            Logs  
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Row>
                    <hr id="k-adm-dash-l6" className='k-border-top-black mt-0 mb-0'></hr>
                    <Row className="mt-0 pe-0 m-0 ">
                      <Tab.Content className='mt-0 pt-1 k-fg-1 k-of-y-auto'>
                        <Tab.Pane eventKey="admin.ProductGeneral">
                          <div className="">
                            <AdminProductContentFormPane
                              productContent={selectedProduct}
                              getUserNameById={getUserNameById}
                              getProductsCallback={getProductsCallback}
                            />
                          </div>
                        </Tab.Pane>
                      </Tab.Content>
                    </Row>
                  </Tab.Container>
                </>
              )
                :
                (<>
                  <div className="minh-400">
                    <Row className='m-0 pt-2'>
                      <Col className='col-12'>
                        <span className='txt-18'></span>
                      </Col>
                    </Row>
                  </div>
                </>
                )}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}


export const AdminEdgeContentTab: React.FunctionComponent<any> = (props:any) => {
  const { 
    users,
    edges,
    selectedEdge,
    handleAdminSelectObject,
    getEdgesCallback,
    handleShowAddEdgeModal,
  } = props;

  const [containerHeight, setContainerHeight] = useState<number>(250); // Default height
  
  
  useEffect(() => {
    helpers.logToOutput('AdminEdgeContentTab selectedProduct has changed: ', selectedEdge);
  },[selectedEdge]);

  useEffect(() => {
    helpers.logToOutput('AdminEdgeContentTab edges have changed: ', edges);
  },[edges]);


  const getUserNameById = (id: string): string | null => {
    const user = users.find((user: any) => user.id === id);
  
    if (user) {
      // If display_name is provided, return it, otherwise construct the name from first, middle, and last.
      return user.display_name || `${user.name.first} ${user.name.middle} ${user.name.last}`.trim();
    }
    
    return null; // Return null if no user is found
  };

  // Function to update the container height based on window size
  const updateHeight = () => {
    const windowHeight = window.innerHeight;
    const newHeight = windowHeight - 250; // Minus the top and bottom banners etc...
    setContainerHeight(newHeight);
  };

  useEffect(() => {
    updateHeight(); // Set initial height
    window.addEventListener('resize', updateHeight);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);



  return (
    <>
      <Row className=''>
        <Col className='col-12'>
          <Row className='m-0'>
            <Col className="">
              <Row className='m-0 p-0'><Col className='m-0 p-0'> <span className='txt-17'>Edge Administration</span></Col></Row>
              <Row className='m-0 p-0'><Col className='m-0 p-0'> <span className='txt-12'>Administer edge ingress/egress for your organisation</span></Col></Row>
            </Col>
            <Col className="text-end k-center-content-hor-right-cen">
              <Button className="k-h-30 k-btn-submit-col txt-14 k-center-content" onClick={handleShowAddEdgeModal} type="submit">Create Edge</Button>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className='mt-2'>
        <Col className="col-3 p-0 ">
          <Row className="m-0">
            <Col className="col-12">
              <div className="">
                <Row className='m-0 ps-2'>
                  <Table className='k-brd-transparent'>
                    <thead className=''>
                      <tr>
                        <th className='pb-1 ps-1 txt-12 color-lightText'>Edge Points</th>
                      </tr>
                    </thead>
                    <div className="k-hmh-600px k-overflow-y-scroll-x-hide-nobars">
                      <tbody className='k-t-body-scroll-admin k-disp-inline-tbl k-wh-100pc'>
                        {edges && edges.map((edge: any, index: number) => {
                          return (
                            <tr className='k-bord-col-trans' key={`admin-users-${edge?.id ?? index}`}>
                              <td className='pt-1 pb-1' onClick={(event) => handleAdminSelectObject(event, { type: 'EDGE', id: edge?.id ?? 'None' })}>
                                <div className={(selectedEdge?.content?.id === edge?.id) ? 'k-bg-selected-light b-rad-5 p-2' : 'k-hover p-2 b-rad-5 k-wh-100pc'}>
                                  <Row>
                                    <Col className='col-2'>
                                      <img className='k-mh-30 mt-1' id={edge?.product} src={imageMap[edge?.product]} alt='Edge Image' />
                                    </Col>
                                    <Col className='col-10'>
                                      <Row><Col className='col-12'>{edge?.name ?? 'None'}</Col></Row>
                                      <Row>
                                        <Col className='col-12 txt-12 color-lightText'>
                                          {(edge?.id ?? 'None').toUpperCase()}
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </div>
                  </Table>
                </Row>
              </div>
            </Col>
          </Row>
        </Col>

        <Col className="col-9 p-0">
          <Row className="m-0 mt-2">
            <Col className="col-12">
              {(selectedEdge && selectedEdge.type === 'EDGE') ? (
                <>
                  <Tab.Container id="edge-content-pane" defaultActiveKey="admin.EdgeGeneral">
                    <Row id="k-adm-dash-l5" className='m-0 p-0 mt-1'>
                      <Nav className="pb-1">
                        <Nav.Item className="">
                          <Nav.Link eventKey="admin.EdgeGeneral" className="p-0 txt-12">
                            General
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="ms-3">
                          <Nav.Link eventKey="admin.EdgeProxy" className="p-0 txt-12 color-lightText">
                            Proxy
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="ms-3">
                          <Nav.Link eventKey="admin.EdgeEndpoint" className="p-0 txt-12 color-lightText">
                            Endpoint
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="ms-3">
                          <Nav.Link eventKey="admin.EdgeLogs" disabled className="p-0 txt-12 color-lightText">
                            Logs  
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Row>
                    <hr id="k-adm-dash-l6" className='k-border-top-black mt-0 mb-0'></hr>
                    <Row className="mt-0 pe-0 m-0 ">
                      <Tab.Content className='mt-0 pt-1 k-fg-1 k-of-y-auto'>
                        <Tab.Pane eventKey="admin.EdgeGeneral">
                          <div className="">
                            <AdminEdgeContentFormPane
                              edgeContent={selectedEdge}
                              getUserNameById={getUserNameById}
                              getEdgesCallback={getEdgesCallback}
                            />
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="admin.EdgeProxy">
                          <div className="">
                            <AdminEdgeContentFormPaneProxy
                              edgeContent={selectedEdge}
                              getUserNameById={getUserNameById}
                              getEdgesCallback={getEdgesCallback}
                            />
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="admin.EdgeEndpoint">
                          <div className="">
                            <AdminEdgeContentFormPaneEndpoint
                              edgeContent={selectedEdge}
                              getUserNameById={getUserNameById}
                              getEdgesCallback={getEdgesCallback}
                            />
                          </div>
                        </Tab.Pane>
                      </Tab.Content>
                    </Row>
                  </Tab.Container>
                </>
              )
                :
                (<>
                  <div className="minh-400">
                    <Row className='m-0 pt-2'>
                      <Col className='col-12'>
                        <span className='txt-18'></span>
                      </Col>
                    </Row>
                  </div>
                </>
                )}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}

export const AdminNumberPlatformContentTab: React.FunctionComponent<any> = (props:any) => {
  const { 
    numbers,
    providers,
    messages,
    providerNumbers,
    getNumbers,
    isProviderRefreshing,
    getProviderDetails,
    handleAdminSelectObject,
    handleProviderRefresh,
    handleShowAddNumberModal,
    selectedObject,
    users
  } = props;

  const [containerHeight, setContainerHeight] = useState<number>(250); // Default height
  const [options, _setOptions] = useState<{ label: string; value: string }[]>([]);
  const [isLoading, setLoading] = useState(false);
  const [isNumberLoading, setNumberLoading] = useState(false);
  const [selectedState, setSelectedState] = useState(null);
  const [messageFilter, setMessageFilter] = useState(''); // State to track the filter value
  const [numberFilter, setNumberFilter] = useState(''); // State to track the filter value
  const [listItems, setListItems] = useState([]); // Now stores data objects
  const [loadingMessage, setLoadingMessage] = useState(''); // For loading messages
  const [apiKey, setApiKey] = useState('');
  const [apiDomain, setApiDomain] = useState('');
  const [apiTag, setApiTag] = useState('');
  const [isMasked, setIsMasked] = useState(true); // State to toggle masking
  const [showModal, setShowModal] = useState(false); // Modal visibility
  const prevIsProviderRefreshingRef = useRef();
  const numberStateOptions = [{value: 'available', label: 'Activate'}, {value: 'suspended', label: 'Suspend'}, {value: 'release', label: 'Release'}]
  const [userList, setUserList] = useState<types.IUserListAttributes[]>([]); 
  const [searchTerm, setSearchTerm] = useState('');
  const [showOverlay, setShowOverlay] = useStateDefault<boolean>(false);

  const toggleOverlay = () => { setShowOverlay(!showOverlay); };

  const toggleMasking = () => setIsMasked(!isMasked);

  // Function to update the container height based on window size
  const updateHeight = () => {
    const windowHeight = window.innerHeight;
    const newHeight = windowHeight - 290; // Minus the top and bottom banners etc...
    setContainerHeight(newHeight);
  };


  useEffect(() => {
    setUserList(users)
  }, [users]);

  const filteredUsers = users
    ? users.filter((user:any) =>
      user.display_name.toLowerCase().includes(searchTerm.toLowerCase())
    )
    : [];
  


  useEffect(() => {
    updateHeight(); // Set initial height
    window.addEventListener('resize', updateHeight);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);

  useEffect(() => {
    const fetchProviderDetails = async () => {
      const currentSelectedObject = selectedObject;
  
      if (currentSelectedObject?.content?.id) {
        const pDetails = await getProviderDetails(currentSelectedObject.content.id);
  
        if (pDetails != null) {
          const parsedApiData = JSON.parse(pDetails.response);
          setApiKey(parsedApiData['key'] || '');
          setApiDomain(parsedApiData['domain'] || '');
          setApiTag(parsedApiData['tag'] || '');
        } else {
          setApiKey('');
          setApiDomain('');
          setApiTag('');
        }
      }
    };
  
    if (selectedObject?.type === 'PROVIDER') {
      fetchProviderDetails();
    }
  }, [selectedObject, getProviderDetails]);
  

  useEffect(() => {
    const prevIsProviderRefreshing = prevIsProviderRefreshingRef.current;
    helpers.logToOutput('AdminNumberPlatformContentTab : 1 providerNumbers :', providerNumbers)
  
    // Detect when refresh starts
    if (!prevIsProviderRefreshing && isProviderRefreshing) {
      // Clear the list when refresh starts
      setListItems([]);
    }
  
    prevIsProviderRefreshingRef.current = isProviderRefreshing;
  
    if (isProviderRefreshing) {
      // Set loading message
      setLoadingMessage('Connecting to provider, please wait...');
    } else {
      // Clear loading message
      setLoadingMessage('Connected, the following numbers have been identified');
      if (providerNumbers && providerNumbers.length > 0) {
        // Set listItems to providerNumbers directly
        setListItems(providerNumbers);
      }
      // No else block: We don't clear the list when there's no data
    }

  }, [providerNumbers, isProviderRefreshing]);


  const _valueRenderer = (numberStateSelected: typeof options) => {

    if (!numberStateSelected.length) {
      return <></>;
    }

    return numberStateSelected.length === 1 ? (
      <span className='k-bg-selected m-1 p-1 b-rad-5'>{numberStateSelected[0].label}</span>
    ) : (
      numberStateSelected.map(({ label }) => <span className='k-bg-selected m-1 p-1 b-rad-5' key={label}>{label}</span>)
    );

    
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    
    
    
    if (selectedObject?.content?.id && selectedObject?.content?.name) {
      updateProviderDetails(selectedObject.content.id, apiKey, apiDomain, selectedObject.content.name, apiTag);
    }
    else {
      helpers.logToOutput('Provider ID not set: ');
    }
  };

  const updateProviderDetails = async (id: string, key: string, domain: string, displayName: string, tag: string) => {
    setLoading(true);
    
    toast.info('Please wait while we update the provider details')
    const putResponse = await api.adminPutProvider({
      id: id,
      body: {
        name: 'general',
        key: key,
        domain: domain,
        display_name: displayName,
        tag: tag
      },
    });

  
    if (putResponse?.status === 200) {
      
      toast.success('Provider details updated');
      setLoading(false);

    } else {
      
      toast.warn('Sorry something has gone wrong, please try again or contact the support desk')
      setLoading(false);
    }
  };

  const updateNumberDetails = async (id: string, state: string, providerID: string) => {
    setNumberLoading(true);
    
    toast.info('Please wait while we update the number details')
    const putResponse = await api.putUpdateNumber({
      id: id,
      body: {
        status: state,
      },
    });

    if (putResponse?.status === 200) {
      
      handleProviderRefresh(providerID)
      getNumbers()
      toast.success('Number details updated');
      setNumberLoading(false);

    } else {
      
      toast.warn('Sorry something has gone wrong, please try again or contact the support desk')
      getNumbers()
      setNumberLoading(false);
    }
  };

  const clearForm = () => {
    setApiKey('');
    setApiDomain('');
    setApiTag('');
    setListItems(null);
  }

  const handleConfirmRelease = (input: string) => {
    if (input === selectedObject?.content?.number) {
      updateNumberDetails(selectedObject.content?.id, selectedState, selectedObject.content?.provider);
      setShowModal(false); // Close modal
    } else {
      toast.warn('The entered number does not match. Please try again.');
    }
  };

  const updateNumber = async (id: string, userId: string) => {
    setNumberLoading(true);
    
    toast.info('Please wait while we update the number details')
    const putResponse = await api.putUpdateNumber({
      id: id,
      body: {
        user_id: userId,
      },
    });

    if (putResponse?.status === 200) {
      getNumbers()
      toast.success('Number details updated');
      setNumberLoading(false);

    } else {
      
      toast.warn('Sorry something has gone wrong, please try again or contact the support desk')
      getNumbers()
      setNumberLoading(false);
    }
  };

  const addNumberUser = (event: any, userId: any) => {
    event.preventDefault();

    if (selectedObject?.content?.id) {
      updateNumber(selectedObject?.content?.id, userId);
    }
    else {
      helpers.logToOutput('Number ID not set: ');
    }
  }

  return (
    <>
      <Row className=''>
        <Col className='col-12'>
          <Row className='m-0'>
            <Col className="">
              <Row className='m-0 p-0'><Col className='m-0 p-0'> <span className='txt-17'>Number Administration</span></Col></Row>
              <Row className='m-0 p-0'><Col className='m-0 p-0'> <span className='txt-12'>Administer numbers your organisation</span></Col></Row>
            </Col>
            <Col className="text-end k-center-content-hor-right-cen">
              <Button className="k-h-30 k-btn-submit-col txt-14 k-center-content" onClick={handleShowAddNumberModal} type="submit">Add Number</Button>
            </Col>
          </Row>
        </Col>
      </Row>
       

      <Row className='mt-2'>
        <Col className="col-12">
          <Row className="m-0 mt-2">
            <Col className="col-12">
              <Tab.Container id="profile-content-pane" defaultActiveKey="admin.NumberProvider">
                <Row id="k-adm-dash-l5" className='m-0 p-0 mt-1'>
                  <Nav className="pb-1">
                    <Nav.Item className="">
                      <Nav.Link eventKey="admin.NumberProvider" className="p-0 txt-12">
                        Provider
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="ms-3">
                      <Nav.Link eventKey="admin.NumberGeneral" className="p-0 txt-12">
                        Numbers
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="ms-3">
                      <Nav.Link eventKey="admin.NumberSMS" className="p-0 txt-12">
                        SMS
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="ms-3">
                      <Nav.Link eventKey="admin.NumberLogs" disabled className="p-0 txt-12 color-lightText">
                        Logs  
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Row>
                <hr id="k-adm-dash-l6" className='k-border-top-black mt-0 mb-0'></hr>
                <Row className="mt-0 pe-0 m-0 ">
                  <Tab.Content className='mt-0 pt-1 k-fg-1 k-of-y-auto'>
                    <Tab.Pane eventKey="admin.NumberGeneral">
                      <div className="">
                        <Row>
                          <Col className="col-3 p-0 ">
                            <Row className="m-0 mt-2">
                              <Col className="col-12">
                                <div className="mb-2">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by number..."
                                    value={numberFilter}
                                    onChange={(e) => setNumberFilter(e.target.value)}
                                  />
                                </div>
                                <div className="k-hmh-600px k-overflow-y-scroll-x-hide-nobars" style={{ height: `${containerHeight}px` }}>
                                  <tbody className='k-t-body-scroll-admin k-disp-inline-tbl k-wh-100pc'>
                                    {numbers
                                      ?.filter((number: any) => {
                                        const resolvedName =
                                          userList.find(u => u.id === number?.user_id)?.display_name ?? '';
                                        const search = numberFilter.toLowerCase();

                                        return (
                                          number?.number?.toLowerCase().includes(search) ||
                                          resolvedName.toLowerCase().includes(search)
                                        );
                                      })
                                      .map((number: any, index: number) => {
                                        const resolvedName =
                                          userList.find(u => u.id === number?.user_id)?.display_name ?? 'None';
                                        return (
                                          <tr
                                            className='k-bord-col-trans'
                                            key={`admin-numbers-${number?.id ?? index}`}
                                          >
                                            <td
                                              className='pt-1 pb-1'
                                              onClick={(event) =>
                                                handleAdminSelectObject(event, {
                                                  type: 'NUMBER',
                                                  id: number?.id ?? 'None',
                                                })
                                              }
                                            >
                                              <div
                                                className={
                                                  selectedObject?.content?.id === number?.id
                                                    ? 'k-bg-selected-light b-rad-5 p-2'
                                                    : 'k-hover p-2 b-rad-5 k-wh-100pc'
                                                }
                                              >
                                                <Row>
                                                  <Col className='col-2'>
                                                    <img
                                                      className='k-mh-30 mt-1'
                                                      id={number?.provider_name ?? 'None'}
                                                      src={
                                                        number?.provider_name
                                                          ? imageMap[number.provider_name.toLowerCase()]
                                                          : imageMap['KuroLogoKOutline']
                                                      }
                                                      alt='Provider Image'
                                                      onClick={() =>
                                                        helpers.logToOutput(
                                                          number?.provider_name
                                                            ? imageMap[number.provider_name.toLowerCase()]
                                                            : imageMap['KuroLogoKOutline']
                                                        )
                                                      }
                                                    />
                                                  </Col>
                                                  <Col className='col-10'>
                                                    <Row>
                                                      <Col className='col-12'>{number?.number ?? 'None'}</Col>
                                                    </Row>
                                                    <Row>
                                                      <Col className='col-12 txt-12 color-lightText'>
                                                        {resolvedName}
                                                      </Col>
                                                    </Row>
                                                  </Col>
                                                </Row>
                                              </div>
                                            </td>
                                          </tr>
                                        );
                                      })}
                                  </tbody>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                          <Col className='col-9 p-0'>
                            <Row className="m-0 mt-2">
                              <Col className="col-12">
                                {(selectedObject && selectedObject.type === 'NUMBER') ? (
                                  <>
                                    <div className="minh-400">
                                      <Row className='m-0 k-pt-3'>
                                        <Col className='col-12'>
                                          <Card className='k-overflow-y-scroll-x-hide-nobars k-b-shadow-none ps-0 growable-div k-overflow-a'>
                                            <Card.Header className='ps-3'>
                                              <Row>
                                                <Col className='col-6'>
                                                  <Row>
                                                    <Col className='col-12'>
                                                      <h4 className='mt-0 mb-0'>{selectedObject?.content?.number ?? 'None'}</h4>
                                                    </Col>
                                                  </Row>
                                                  <Row>
                                                    <Col className='col-12 txt-12 color-lightText'>
                                                      {(selectedObject?.content?.status ?? 'None').toUpperCase()} / {(selectedObject.content?.countryCode ?? 'None').toUpperCase()} {(selectedObject.content?.country ?? 'None').toUpperCase()}
                                                    </Col>
                                                  </Row>
                                                </Col>
                                                <Col className=''>  
                                                  <Row>
                                                    <Col className="col-9">
                                                      <Select
                                                        options={numberStateOptions}
                                                        isMulti={false}
                                                        onChange={(selectedOption) => setSelectedState(selectedOption?.value)} // Update selectedState
                                                      />
                                                    </Col>
                                                    <Col className="col-3 d-flex justify-content-center align-items-center">
                                                      <Button
                                                        className="k-min-w-103 p-2"
                                                        variant="outline-dark"
                                                        disabled={isNumberLoading || !selectedState} // Disable if loading or no selection
                                                        onClick={() => {
                                                          if (selectedState === 'release') {
                                                            setShowModal(true); // Show confirmation modal for "Release"
                                                          } else {
                                                            updateNumberDetails(selectedObject.content?.id, selectedState, selectedObject.content?.provider);
                                                          }
                                                        }}
                                                      >
                                                        {isNumberLoading ? 'Updating...' : 'Update'}
                                                      </Button>
                                                    </Col>
                                                  </Row>
                                                </Col>
                                              </Row>
                                            </Card.Header>
                                            <Card.Body className='p-0 pt-4'>
                                              <Row>
                                                <Col md={6}>
                                                  <Card>
                                                    <Card.Header className='p-2 ps-3 txt-14' ><strong>General</strong></Card.Header>
                                                    <ListGroup variant="flush txt-12">
                                                      <ListGroup.Item>
                                                        <Row>
                                                          <Col className='col-3'><strong>Provider:</strong></Col>
                                                          <Col className='col-9'>{(selectedObject.content?.provider_name ?? 'None').toUpperCase()}</Col>
                                                        </Row>
                                                      </ListGroup.Item>
                                                      <ListGroup.Item>
                                                        <Row>
                                                          <Col className='col-3'><strong>User:</strong></Col>
                                                          <Col className='col-8 pe-0'>{(userList.find(u => u.id === selectedObject.content?.user_id)?.display_name ?? 'None')}</Col>
                                                          <Col className='m-0 p-0 col-1 k-center-content k-hover b-rad-5'>
                                                            <OverlayTrigger
                                                              show={showOverlay}
                                                              key={'oTrigKey-number'}
                                                              placement="right-start"
                                                              overlay={
                                                                <Popover id={'popover-positioned-oTrigKey-group'} className="k-z-ind-99999 k-no-pop-arrow ms-4 k-w-220">
                                                                  <Popover.Header as="h3">
                                                                    <Row>
                                                                      <Col className="col-10 k-panel-cent-vert">Assign Number to User</Col>
                                                                      <Col className="col-2 k-panel-cent-vert k-center-content-hor-right">
                                                                        <div>
                                                                          <OverlayTrigger
                                                                            trigger="hover"
                                                                            placement="top"
                                                                            delay={{ show: 1000, hide: 200 }}
                                                                            overlay={
                                                                              <Popover id={'popover-m-groupuseradd'} className="k-z-ind-popup b-rad-10">
                                                                                <Popover.Body className="p-1 m-0 txt-weight-200 txt-12 text-center">
                                                                                Click to close the menu
                                                                                </Popover.Body>
                                                                              </Popover>
                                                                            }
                                                                          >
                                                                            <img
                                                                              className="k-mh-20 k-opac-50pc k-pointer"
                                                                              onClick={toggleOverlay}
                                                                              src={closeBtn}
                                                                              alt="Close"
                                                                            />
                                                                          </OverlayTrigger>
                                                                        </div>
                                                                      </Col>
                                                                    </Row>
                                                                  </Popover.Header>

                                                                  <Popover.Body className="p-0">
                                                                    <Nav className="pb-2">

                                                                      <Form.Control
                                                                        type="text"
                                                                        placeholder="Search users..."
                                                                        value={searchTerm}
                                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                                        className="m-2"
                                                                      />

                                                                      {filteredUsers.map((user: { id: any; display_name: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | (string & React.ReactElement<any, string | React.JSXElementConstructor<any>>) | (string & Iterable<React.ReactNode>) | (string & React.ReactPortal) | (number & React.ReactElement<any, string | React.JSXElementConstructor<any>>) | (number & Iterable<React.ReactNode>) | (number & React.ReactPortal) | (false & React.ReactElement<any, string | React.JSXElementConstructor<any>>) | (false & Iterable<React.ReactNode>) | (false & React.ReactPortal) | (true & React.ReactElement<any, string | React.JSXElementConstructor<any>>) | (true & Iterable<React.ReactNode>) | (true & React.ReactPortal) | (React.ReactElement<any, string | React.JSXElementConstructor<any>> & string) | (React.ReactElement<any, string | React.JSXElementConstructor<any>> & number) | (React.ReactElement<any, string | React.JSXElementConstructor<any>> & false) | (React.ReactElement<any, string | React.JSXElementConstructor<any>> & true) | (React.ReactElement<any, string | React.JSXElementConstructor<any>> & Iterable<React.ReactNode>) | (React.ReactElement<any, string | React.JSXElementConstructor<any>> & React.ReactPortal) | (Iterable<React.ReactNode> & string) | (Iterable<React.ReactNode> & number) | (Iterable<React.ReactNode> & false) | (Iterable<React.ReactNode> & true) | (Iterable<React.ReactNode> & React.ReactElement<any, string | React.JSXElementConstructor<any>>) | (Iterable<React.ReactNode> & React.ReactPortal) | (React.ReactPortal & string) | (React.ReactPortal & number) | (React.ReactPortal & false) | (React.ReactPortal & true) | (React.ReactPortal & React.ReactElement<any, string | React.JSXElementConstructor<any>>) | (React.ReactPortal & Iterable<React.ReactNode>) | (Iterable<React.ReactNode> & string) | (Iterable<React.ReactNode> & number) | (Iterable<React.ReactNode> & false) | (Iterable<React.ReactNode> & true) | (Iterable<React.ReactNode> & React.ReactElement<any, string | React.JSXElementConstructor<any>>) | (Iterable<React.ReactNode> & Iterable<React.ReactNode>) | (Iterable<React.ReactNode> & React.ReactPortal); name: { first: any; }; }, index: any) => {
                                                                        
                                                                        return (
                                                                          <NavDropdown.Item
                                                                            className="k-inputText12 p-2 mx-2 k-hover"
                                                                            key={`paneGroupEditForm.Dropdown.${index}`}
                                                                            onClick={(event) => {
                                                                              addNumberUser(event,user.id);
                                                                              toggleOverlay();
                                                                            }
                                                                            }
                                                                          >
                                                                            {user.display_name}
                                                                          </NavDropdown.Item>
                                                                        );
                                                                      })}
                                                                    </Nav>
                                                                  </Popover.Body>
                                                                </Popover>
                                                              }
                                                            >
                                                              <Button
                                                                variant="link"
                                                                onClick={toggleOverlay}
                                                                className="k-bg-trans m-0 p-0 k-border-none k-center-content-hor-right  "
                                                              >
                                                                <AiOutlineUserAdd />
                                                              </Button>
                                                            </OverlayTrigger>
                                                          </Col>
                                                        </Row>
                                                      </ListGroup.Item>
                                                      <ListGroup.Item>
                                                        <Row>
                                                          <Col className='col-3'><strong>Attached Device:</strong> </Col>
                                                          <Col className='col-9 pe-0'>{(selectedObject.content?.device_name ?? 'None').toUpperCase()}</Col>
                                                        </Row>
                                                      </ListGroup.Item>
                                                    </ListGroup>
                                                  </Card>
                                                </Col>

                                                <Col md={6}>
                                                  <Card>
                                                    <Card.Header className='p-2 ps-3 txt-14'><strong>Capabilities</strong></Card.Header>
                                                    <ListGroup variant="flush txt-12">
                                                      <ListGroup.Item>
                                                        <Row>
                                                          <Col className='col-auto'><strong>SMS</strong></Col>
                                                          <Col className='col-auto'>{selectedObject.content?.sms ? 'True' : 'False'}</Col>
                                                        </Row>
                                                      </ListGroup.Item>
                                                      <ListGroup.Item>
                                                        <Row>
                                                          <Col className='col-auto'><strong>Voice</strong></Col>
                                                          <Col className='col-auto'>{selectedObject.content?.voice ? 'True' : 'False'}</Col>
                                                        </Row>
                                                      </ListGroup.Item>
                                                    </ListGroup>
                                                  </Card>
                                                </Col>
                                              </Row>

                                              <Row className="mt-3">
                                                <Col md={12}>
                                                  <Card>
                                                    <Card.Header className='p-2 ps-3 txt-14'><strong>Usage</strong></Card.Header>
                                                    <ListGroup variant="flush txt-12">
                                                      {/*content?.share?.SS ? content.share.SS.map((ss:any, index:any) => (
                                                        <ListGroup.Item key={index}>
                                                          <strong>User {index + 1}:</strong> {getUserNameById(ss) ?? 'Unknown User'}
                                                        </ListGroup.Item>
                                                      )) : <ListGroup.Item>Product not shared</ListGroup.Item>*/}
                                                    </ListGroup>
                                                  </Card>
                                                </Col>
                                              </Row>
                                            </Card.Body>
                                          </Card>
                                        </Col>
                                      </Row>
                                    </div> 
                                  </>
                                )
                                  :
                                  (<>
                                    <div className="minh-400">
                                      <Row className='m-0 pt-2'>
                                        <Col className='col-12'>
                                          <span className='txt-18'></span>
                                        </Col>
                                      </Row>
                                    </div>
                                  </>
                                  )}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="admin.NumberProvider">
                      <div className="">
                        <Row>
                          <Col className="col-3 p-0 ">
                            <Row className="m-0 mt-2">
                              <Col className="col-12">
                                <div className="k-hmh-600px k-overflow-y-scroll-x-hide-nobars">
                                  <tbody className='k-t-body-scroll-admin k-disp-inline-tbl k-wh-100pc'>
                                    {providers && providers.map((provider: any, index: number) => {
                                      return (
                                        <tr className='k-bord-col-trans' key={`admin-providers-${provider.id}`}>
                                          <td key={`admin-providers-tr-td=${index}`} className='pt-1 pb-1' onClick={(event)=> {clearForm(); handleAdminSelectObject(event, {type: 'PROVIDER', id: provider.id})}} >
                                            <div className={(selectedObject?.content?.id === provider.id) ? 'k-bg-selected-light b-rad-5 p-2' : 'k-hover p-2 b-rad-5'}>
                                              <Row>
                                                <Col xs="auto">
                                                  <img className='k-mh-30 mt-1' id={provider?.name ?? 'None'} src={imageMap[provider?.name] ?? ''} alt='Product Image' />
                                                </Col>
                                                <Col>
                                                  <Row><Col className='col-12'>{provider?.name || ''}</Col></Row>
                                                  <Row><Col className='col-12 txt-12 color-lightText'>{(provider?.state ?? 'None').toUpperCase()}</Col></Row>
                                                </Col>
                                              </Row>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    })}
                                  </tbody>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                          <Col className='col-9 p-0'>
                            <Row className="m-0 mt-2">
                              <Col className="col-12">
                                {(selectedObject && selectedObject.type === 'PROVIDER') ? (
                                  <>
                                    <div className="minh-400">
                                      <Row className='m-0 k-pt-3'>
                                        <Col className='col-12'>
                                          <Card className='k-overflow-y-scroll-x-hide-nobars k-b-shadow-none ps-0 growable-div k-overflow-a'>
                                            <Card.Header className='ps-3'>
                                              <Row>
                                                <Col className='col-6'>
                                                  <Row>
                                                    <Col className='col-12'>
                                                      <h4 className='mt-0 mb-0'>{selectedObject?.content?.name ?? 'None'}</h4>
                                                    </Col>
                                                  </Row>
                                                  <Row>
                                                    <Col className='col-12 txt-12 color-lightText'>
                                                      {(selectedObject?.content?.state ?? 'None').toUpperCase()}
                                                    </Col>
                                                  </Row>
                                                </Col>
                                                <Col className=''>  
                                                  <Row className='d-flex d-flex justify-content-end align-items-center'>
                                                    <Col className='col-3 d-flex justify-content-end align-items-center'>
                                                      <Button className="k-min-w-103 p-2" variant="outline-dark" type="submit" form="apiForm" disabled={isLoading || selectedObject?.content?.state !== 'active'}>
                                                        {isLoading ? 'updating...' : 'update'}
                                                      </Button>
                                                    </Col>
                                                  </Row>
                                                </Col>
                                              </Row>
                                            </Card.Header>
                                            <Card.Body className='p-0 pt-4'>
                                              <Row>
                                                <Col md={12}>
                                                  <Form id="apiForm" onSubmit={handleSubmit}>
                                                    <Row>
                                                      <Col md={12}>
                                                        <Form.Group controlId="apiKey" className="mb-3 px-2">
                                                          <Form.Label>API Key</Form.Label>
                                                          <InputGroup className="">
                                                            <Form.Control
                                                              type={isMasked ? 'password' : 'text'} 
                                                              placeholder="Enter API Key"
                                                              value={apiKey}
                                                              onChange={(e) => setApiKey(e.target.value)}
                                                              required
                                                              disabled={isLoading || selectedObject?.content?.state !== 'active'}
                                                            />
                                                            <InputGroup.Text id="apikeyinput" onClick={toggleMasking} style={{ cursor: 'pointer' }}>
                                                              {isMasked ? (
                                                                <FontAwesomeIcon icon={faEyeSlash} />
                                                              ) : (
                                                                <FontAwesomeIcon icon={faEye} />
                                                              )}
                                                            </InputGroup.Text>
                                                          </InputGroup>
                                                        </Form.Group>
                                                      </Col>
                                                      <Col md={12}>
                                                        <Form.Group controlId="apiDomain" className="mb-3 px-2">
                                                          <Form.Label>API Domain</Form.Label>
                                                          <InputGroup className="">
                                                            <InputGroup.Text>https://</InputGroup.Text>
                                                            <Form.Control
                                                              type="text"
                                                              placeholder="Enter API Domain"
                                                              value={apiDomain}
                                                              onChange={(e) => setApiDomain(e.target.value)}
                                                              required
                                                              disabled={isLoading || selectedObject?.content?.state !== 'active'}
                                                            />
                                                          </InputGroup>
                                                        </Form.Group>
                                                      </Col>
                                                      <Col md={12}>
                                                        <Form.Group controlId="apiTag" className="mb-3 px-2">
                                                          <Form.Label>Tag</Form.Label>
                                                          <InputGroup className="">
                                                            <Form.Control
                                                              type="text"
                                                              placeholder="Enter Tag"
                                                              value={apiTag}
                                                              onChange={(e) => setApiTag(e.target.value)}
                                                              required
                                                              disabled={isLoading || selectedObject?.content?.state !== 'active'}
                                                            />
                                                          </InputGroup>
                                                        </Form.Group>
                                                      </Col>
                                                    </Row>
                                                  </Form>
                                                </Col>
                                              </Row>

                                              <Row className="mt-3">
                                                <Col md={12}>
                                                  <Card>
                                                    <Card.Header className='ps-3 py-2'>
                                                      <Row>
                                                        <Col className='col-6'>
                                                          <h5 className='mt-0 mb-0'>Numbers</h5>
                                                        </Col>
                                                        <Col className=''>  
                                                          <Row className='d-flex d-flex justify-content-end align-items-center'>
                                                            <Col className='col-3 d-flex justify-content-end align-items-center'>
                                                              <Button className="k-min-w-103 p-0" variant="outline-dark" onClick={() => handleProviderRefresh(selectedObject?.content?.id)} disabled={isProviderRefreshing || selectedObject?.content?.state !== 'active'}>
                                                                {isProviderRefreshing ? 'refreshing...' : 'refresh'}
                                                              </Button>
                                                            </Col>
                                                          </Row>
                                                        </Col>
                                                      </Row>
                                                    </Card.Header>
                                                    <Card.Body className='p-0 pt-4 px-2'>
                                                      {loadingMessage && <div>{loadingMessage}</div>}
                                                      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                                        <Table striped bordered hover size="sm">
                                                          <thead>
                                                            <tr>
                                                              <th className='p-1'>Number</th>
                                                              <th className='p-1'>Country</th>
                                                              <th className='p-1'>Capabilities</th>
                                                              {/* Add more columns as needed */}
                                                            </tr>
                                                          </thead>
                                                          <tbody>
                                                            {Array.isArray(listItems) && listItems.map((item, index) => (
                                                              <tr key={index}>
                                                                <td className="p-1">{item.number}</td>
                                                                <td className="p-1">{item.country}</td>
                                                                <td className="p-1">
                                                                  {[item.sms && 'SMS', item.voice && 'Voice'].filter(Boolean).join(', ')}
                                                                </td>
                                                              </tr>
                                                            ))}
                                                          </tbody>
                                                        </Table>
                                                      </div>
                                                    </Card.Body>
                                                  </Card>
                                                </Col>
                                              </Row>
                                            </Card.Body>
                                          </Card>
                                        </Col>
                                      </Row>
                                    </div> 
                                  </>
                                )
                                  :
                                  (<>
                                    <div className="minh-400">
                                      <Row className='m-0 pt-2'>
                                        <Col className='col-12'>
                                          <span className='txt-18'></span>
                                        </Col>
                                      </Row>
                                    </div>
                                  </>
                                  )}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="admin.NumberSMS">
                      <div className="">
                        <Row>
                          <Col className="col-3 p-0 ">
                            <Row className="m-0 mt-2">
                              <Col className="col-12">
                                <div className="mb-2">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by number..."
                                    value={messageFilter}
                                    onChange={(e) => setMessageFilter(e.target.value)}
                                  />
                                </div>
                                <div className="k-hmh-600px k-overflow-y-scroll-x-hide-nobars">
                                  <tbody className='k-t-body-scroll-admin k-disp-inline-tbl k-wh-100pc'>
                                    { messages
                                      ?.filter((message: any) =>
                                        message?.destination?.toLowerCase().includes(messageFilter.toLowerCase())
                                      ) // Apply the filter
                                      .sort((a: any, b: any) => (b.time_epoch ?? 0) - (a.time_epoch ?? 0)) // Sort by time_epoch
                                      .map((message: any, index: number) => {
                                        return (
                                          <tr className='k-bord-col-trans' key={`admin-messages-${message?.message_id ?? index}`}>
                                            <td className='pt-1 pb-1' onClick={(event) => handleAdminSelectObject(event, { type: 'MESSAGE', id: message?.message_id ?? 'None' })}>
                                              <div className={(selectedObject?.content?.message_id === message?.message_id) ? 'k-bg-selected-light b-rad-5 p-2' : 'k-hover p-2 b-rad-5 k-wh-100pc'}>
                                                <Row>
                                                  <Col className='col-2'>
                                                    <img className='k-mh-30 mt-1' id={message?.provider ?? 'None'} src={imageMap['message'] ?? ''} alt='Product Image' />
                                                  </Col>
                                                  <Col className='col-10'>
                                                    <Row className='ms-1'>
                                                      <Col className='col-12'>{message?.destination ?? 'None'}</Col></Row>
                                                    <Row className='ms-1'>
                                                      <Col className='col-12 txt-12 color-lightText'>
                                                        {(helpers.getConditionalDateTime(message?.time_epoch, true) ?? 'None').toUpperCase()}
                                                      </Col>
                                                    </Row>
                                                  </Col>
                                                </Row>
                                              </div>
                                            </td>
                                          </tr>
                                        )
                                      })}
                                  </tbody>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                          <Col className='col-9 p-0'>
                            <Row className="m-0 mt-2">
                              <Col className="col-12">
                                {(selectedObject && selectedObject.type === 'MESSAGE') ? (
                                  <>
                                    <div className="minh-400">
                                      <Row className='m-0 k-pt-3'>
                                        <Col className='col-12'>
                                          <Card className='k-overflow-y-scroll-x-hide-nobars k-b-shadow-none ps-0 growable-div k-overflow-a'>
                                            <Card.Header className='ps-3'>
                                              <Row>
                                                <Col className='col-6'>
                                                  <Row>
                                                    <Col className='col-12'>
                                                      <h4 className='mt-0 mb-0'>{selectedObject?.content?.destination ?? 'None'}</h4>
                                                    </Col>
                                                  </Row>
                                                  <Row>
                                                    <Col className='col-12 txt-12 color-lightText'>
                                                      {selectedObject?.content?.product_id ?? 'Unassociated'}
                                                    </Col>
                                                  </Row>
                                                </Col>
                                              </Row>
                                            </Card.Header>
                                            <Card.Body className='p-0 pt-4'>
                                              <Row>
                                                <Col md={6}>
                                                  <Card>
                                                    <Card.Header className='p-2 ps-3 txt-14 b-rad-t-5' ><strong>General</strong></Card.Header>
                                                    <ListGroup variant="flush txt-12">
                                                      <ListGroup.Item>
                                                        <Row>
                                                          <Col className='col-3'><strong>From:</strong></Col>
                                                          <Col className='col-9'>{(selectedObject.content?.sender ?? 'None')}</Col>
                                                        </Row>
                                                      </ListGroup.Item>
                                                      <ListGroup.Item>
                                                        <Row>
                                                          <Col className='col-3'><strong>To:</strong> </Col>
                                                          <Col className='col-9 pe-0'>{(selectedObject.content?.destination ?? 'None')}</Col>
                                                        </Row>
                                                      </ListGroup.Item>
                                                    </ListGroup>
                                                  </Card>
                                                </Col>

                                                <Col md={6}>
                                                  <Card>
                                                    <Card.Header className='p-2 ps-3 txt-14 b-rad-t-5'><strong>Status</strong></Card.Header>
                                                    <ListGroup variant="flush txt-12">
                                                      <ListGroup.Item>
                                                        <Row>
                                                          <Col className='col-3'><strong>Delivered:</strong> </Col>
                                                          <Col className='col-9 pe-0'>{selectedObject.content?.delivered === undefined ? 'None' : selectedObject.content.delivered === 0 ? 'False' : 'True'}</Col>
                                                        </Row>
                                                      </ListGroup.Item>
                                                      <ListGroup.Item>
                                                        <Row>
                                                          <Col className='col-auto'><strong>Received Time</strong></Col>
                                                          <Col className='col-auto'>{(helpers.getConditionalDateTime(selectedObject?.content?.time_epoch, true) ?? 'None').toUpperCase()}</Col>
                                                        </Row>
                                                      </ListGroup.Item>
                                                    </ListGroup>
                                                  </Card>
                                                </Col>
                                              </Row>

                                              <Row className="mt-3">
                                                <Col md={12}>
                                                  <Card>
                                                    <Card.Header className='p-2 ps-3 txt-14 b-rad-t-5'>
                                                      <Row>
                                                        <Col className='col-12'>
                                                          <Row>
                                                            <Col className='col-12'>
                                                              <strong>Message </strong>
                                                            </Col>
                                                          </Row>
                                                          <Row>
                                                            <Col className='col-12 txt-12 color-lightText'>
                                                              ID:{selectedObject.content?.message_id ?? 'None'}
                                                            </Col>
                                                          </Row>
                                                        </Col>
                                                      </Row>
                                                    </Card.Header>
                                                    <Card.Body className='k-content-cornsilk-bg b-rad-b-5'>
                                                      {selectedObject.content?.clean_text ?? 'None'}
                                                    </Card.Body>
                                                  </Card>
                                                </Col>
                                              </Row>
                                            </Card.Body>
                                          </Card>
                                        </Col>
                                      </Row>
                                    </div> 
                                  </>
                                )
                                  :
                                  (<>
                                    <div className="minh-400">
                                      <Row className='m-0 pt-2'>
                                        <Col className='col-12'>
                                          <span className='txt-18'></span>
                                        </Col>
                                      </Row>
                                    </div>
                                  </>
                                  )}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
                </Row>
              </Tab.Container>
            </Col>
          </Row>
        </Col>
      </Row>

      <ConfirmReleaseModal
        show={showModal}
        number={selectedObject?.content?.number || ''}
        onClose={() => setShowModal(false)}
        onConfirm={handleConfirmRelease}
      />
    </>
  );
}

const AdminProductContentFormPane: React.FunctionComponent<{ productContent: types.ProductContent, getUserNameById: (id: string) => string | null, getProductsCallback: any }> = 
({ productContent, getUserNameById, getProductsCallback }) => {

  
  const authContext = useContext(authContextHelper.AuthContext);
  const [controlled, setControlled] = useState(true);
  const [ownership, setOwnership] = useState(false);
  const [content, setContent] = useState<any>({});

  useEffect(() => {
    //Get Header height
    const header = document.querySelector('#k-app-header') as HTMLElement | null;
    const headerHeight = header ? header.offsetHeight : 0;
    
  
    const layerOne = document.querySelector('#k-adm-dash-l1') as HTMLElement | null;
    const layerOneHeight = layerOne ? layerOne.offsetHeight : 0;
    
  
    const layerTwo = document.querySelector('#k-adm-dash-l2') as HTMLElement | null;
    const layerTwoHeight = layerTwo ? layerTwo.offsetHeight : 0;
    
  
    const layerThree = document.querySelector('#k-adm-dash-l3') as HTMLElement | null;
    const layerThreeHeight = layerThree ? layerThree.offsetHeight : 0;
    
  
    const layerFour = document.querySelector('#k-adm-dash-l4') as HTMLElement | null;
    const layerFourHeight = layerFour ? layerFour.offsetHeight : 0;
    
  
    const layerFive = document.querySelector('#k-adm-dash-l5') as HTMLElement | null;
    const layerFiveHeight = layerFive ? layerFive.offsetHeight : 0;
    
  
    const layerSix = document.querySelector('#k-adm-dash-l6') as HTMLElement | null;
    const layerSixHeight = layerSix ? layerSix.offsetHeight : 0;
    
  
    const footerLayer = document.querySelector('#k-app-footer-le') as HTMLElement | null;
    const footerLayerHeight = footerLayer ? footerLayer.offsetHeight : 0;
    

    const hackHeight = 100;
  
    const totalHeight =
      headerHeight +
      layerOneHeight +
      layerTwoHeight +
      layerThreeHeight +
      layerFourHeight +
      layerFiveHeight +
      layerSixHeight +
      hackHeight;
  
    document.documentElement.style.setProperty('--remaining-height', `calc(100vh - ${totalHeight}px - ${footerLayerHeight}px)`);
  }, []);
  
  useEffect(() => {
    helpers.logToOutput('AdminProductContentFormPane extractProductCode : ',extractProductCode(productContent.content));
    setContent(extractProductCode(productContent.content));
  }, [productContent]);
  
  useEffect(() => {
    if (!content?.id) return; // Check if content.id exists before running the effect
  
    
    
    
  
    if (content?.user && content.user !== authContext.userProfile.attributes.sub) {
      
      setOwnership(false);
  
      if (content?.share?.SS) {
        
        const isMatching = content.share.SS.some((ss: any) => ss === authContext.userProfile.attributes.sub);
        if (isMatching) {
          
          setControlled(false);
        } else {
          
          setControlled(true);
        }
      } else {
        
        setControlled(true);
      }
    } else {
      
      setControlled(false);
      setOwnership(true);
    }
  }, [content.id, authContext.userProfile.attributes.sub, content.user, content.share?.SS]);
  
  const extractProductCode = (data:any) => {
    const parts = data['product-code']?.split('_') || [];
    if (parts.length < 7) return data;
    return {
      ...data,
      provider: parts[0],
      region: parts[1],
      instanceType: parts[2],
      os: parts[3],
      category: parts[4],
      size: parts[5],
      capacity: parts[6],
    };   
  };

  // Function to handle control with API call
  const handleControlClick = async (newControlStatus: boolean, prod_id: string) => {
    try {
      
      // Prepare the body for the API request (assuming an object structure)
      const query = {
        id: prod_id,
        body: {
          action: !newControlStatus ? 'ADD' : 'DELETE',
          user: authContext.userProfile.attributes.sub
        }
      };

      const response = await api.setAdminControl(query);

      if (response.status === DEFAULT_API_RESULT.SUCCESS) {
        // If API call succeeds, update the state
        
        setControlled(newControlStatus);
      } else {
        // If the response indicates failure, handle it
        
      }
      getProductsCallback()
    } catch (error) {
      // Handle any unexpected errors during the API call
      
      getProductsCallback()
    }
  };

  const handleResetClick = async (prod_id: any) => {
    //helpers.logToOutput('handleResetClick selectedProduct.content.id: ',selectedProduct.content.id)
    helpers.logToOutput('handleResetClick prod_id: ',prod_id)
    try {
      
      // Prepare the body for the API request (assuming an object structure)
      toast.info('Please wait while we reset your product')
      const query = {
        body: {
          id: prod_id
        }
      };

      const response = await api.resetProduct(query);

      if (response.status === DEFAULT_API_RESULT.SUCCESS) {
        // If API call succeeds, update the state
        toast.success('Successfully reset product')
      } else {
        // If the response indicates failure, handle it
        toast.error('Whoops .... something has gone wrong with product reset')
      }
      getProductsCallback()
    } catch (error) {
      // Handle any unexpected errors during the API call
      
      getProductsCallback()
    }
  };
  

  return (
    <>
      <Card className='k-overflow-y-scroll-x-hide-nobars k-b-shadow-none ps-0 growable-div k-overflow-a'>
        <Card.Header className='ps-3'>
          <Row>
            <Col className='col-7'>
              <Row>
                <Col className='col-12'>
                  <h4 className='mt-0 mb-0'>{content?.tags?.kname ?? 'None'}</h4>
                </Col>
              </Row>
              <Row>
                <Col className='col-12 txt-12 color-lightText'>
                  {getUserNameById(content?.user) ?? 'Unknown User'} / {(content?.provider ?? 'None').toUpperCase()} / {variables?.regionToLocationMap?.[content?.region] ?? 'None'}
                </Col>
              </Row>
            </Col>
            {!ownership ? 
              <>
                <Col className='k-align-content-center d-flex justify-content-end'>
                  <Button variant="success" type="submit" 
                    disabled={!controlled} size="sm" className="k-btn"
                    onClick={() => handleControlClick(!controlled, content.id)}>
                      Control
                  </Button>
                </Col>
                <Col className='col-auto k-align-content-center d-flex'>
                  <Button variant="warning" type="submit" 
                    disabled={controlled} size="sm" className="k-btn"
                    onClick={() => handleControlClick(!controlled, content.id)}>
                    Release
                  </Button>
                </Col>
                <Col className='col-auto k-align-content-center d-flex'>
                  <Button variant="info" type="submit" 
                    size="sm" className="k-btn"
                    onClick={() => handleResetClick(content.id)}>
                          Reset
                  </Button>
                </Col>
              </> : 
              <>
                <Col className='k-align-content-center d-flex justify-content-end'>
                  <Button variant="info" type="submit" 
                    size="sm" className="k-btn"
                    onClick={() => handleResetClick(content.id)}>
                          Reset
                  </Button>
                </Col>
              </>
            }
                     
          </Row>
        </Card.Header>
        <Card.Body className='p-0 pt-4'>
          <Row>
            <Col md={6}>
              <Card>
                <Card.Header className='p-2 ps-3 txt-14' ><strong>Product Info</strong></Card.Header>
                <ListGroup variant="flush txt-12">
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'><strong>Provider:</strong></Col>
                      <Col className='col-9'>{(content?.provider ?? 'None').toUpperCase()}</Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'><strong>Region:</strong> </Col>
                      <Col className='col-9'>{variables?.regionToLocationMap?.[content?.region] ?? 'None'} / {content?.region ?? 'None'} </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'><strong>State:</strong> </Col>
                      <Col className='col-9'>{content?.state ?? 'None'}</Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'>
                        <strong>{(content?.provider ?? 'None').toUpperCase()} ID:</strong>
                      </Col>
                      <Col className='col-9'>
                        {
                          content.product === 'android' ? (
                            <>
                              {content.host_id ? content.host_id : 'None'}{' '}
                            </>
                          ) : (
                            <>
                              {content.cloud_ids && (content.id in content.cloud_ids)
                                ? content.cloud_ids[content.id]
                                : 'None'}{' '}
                              /{' '}
                              {content.cloud_ids && (`connect:${content.id}` in content.cloud_ids)
                                ? content.cloud_ids[`connect:${content.id}`]
                                : 'None'}
                            </>
                          )
                        }
                      </Col>
                    </Row>
                  </ListGroup.Item>
                </ListGroup>
              </Card>
            </Col>

            <Col md={6}>
              <Card>
                <Card.Header className='p-2 ps-3 txt-14'><strong>Network Info</strong></Card.Header>
                <ListGroup variant="flush txt-12">
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-2'><strong>IPv4:</strong></Col>
                      <Col className='col-10'>{content?.ipv4 ?? 'None'}</Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-2'><strong>IPv6:</strong> </Col>
                      <Col className='col-10'>{content?.ipv6 ?? 'None'}</Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-2'><strong>DNS:</strong> </Col>
                      <Col className='col-10'>{content?.dns?.domain ?? 'None'}</Col>
                    </Row>
                  </ListGroup.Item>
                </ListGroup>
              </Card>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={12}>
              <Card>
                <Card.Header className='p-2 ps-3 txt-14'><strong>Share Details</strong></Card.Header>
                <ListGroup variant="flush txt-12">
                  {content?.share?.SS ? content.share.SS.map((ss:any, index:any) => (
                    <ListGroup.Item key={index}>
                      <strong>User {index + 1}:</strong> {getUserNameById(ss) ?? 'Unknown User'}
                    </ListGroup.Item>
                  )) : <ListGroup.Item>Product not shared</ListGroup.Item>}
                </ListGroup>
              </Card>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};


const AdminEdgeContentFormPane: React.FunctionComponent<{ edgeContent: types.EdgeContent, getUserNameById: (id: string) => string | null, getEdgesCallback: any }> = 
({ edgeContent, getUserNameById, getEdgesCallback }) => {

  
  const authContext = useContext(authContextHelper.AuthContext);
  const [controlled, setControlled] = useState(true);
  const [ownership, setOwnership] = useState(false);
  const [content, setContent] = useState<any>({});
  const [showQr, setShowQr] = useState(false);

  useEffect(() => {
    //Get Header height
    const header = document.querySelector('#k-app-header') as HTMLElement | null;
    const headerHeight = header ? header.offsetHeight : 0;
    
  
    const layerOne = document.querySelector('#k-adm-dash-l1') as HTMLElement | null;
    const layerOneHeight = layerOne ? layerOne.offsetHeight : 0;
    
  
    const layerTwo = document.querySelector('#k-adm-dash-l2') as HTMLElement | null;
    const layerTwoHeight = layerTwo ? layerTwo.offsetHeight : 0;
    
  
    const layerThree = document.querySelector('#k-adm-dash-l3') as HTMLElement | null;
    const layerThreeHeight = layerThree ? layerThree.offsetHeight : 0;
    
  
    const layerFour = document.querySelector('#k-adm-dash-l4') as HTMLElement | null;
    const layerFourHeight = layerFour ? layerFour.offsetHeight : 0;
    
  
    const layerFive = document.querySelector('#k-adm-dash-l5') as HTMLElement | null;
    const layerFiveHeight = layerFive ? layerFive.offsetHeight : 0;
    
  
    const layerSix = document.querySelector('#k-adm-dash-l6') as HTMLElement | null;
    const layerSixHeight = layerSix ? layerSix.offsetHeight : 0;
    
  
    const footerLayer = document.querySelector('#k-app-footer-le') as HTMLElement | null;
    const footerLayerHeight = footerLayer ? footerLayer.offsetHeight : 0;
    

    const hackHeight = 100;
  
    const totalHeight =
      headerHeight +
      layerOneHeight +
      layerTwoHeight +
      layerThreeHeight +
      layerFourHeight +
      layerFiveHeight +
      layerSixHeight +
      hackHeight;
  
    document.documentElement.style.setProperty('--remaining-height', `calc(100vh - ${totalHeight}px - ${footerLayerHeight}px)`);
  }, []);
  
  useEffect(() => {
    helpers.logToOutput('AdminProductContentFormPane extractProductCode : ',extractProductCode(edgeContent.content));
    setContent(extractProductCode(edgeContent.content));
  }, [edgeContent]);
  
  useEffect(() => {
    if (!content?.id) return; // Check if content.id exists before running the effect

  
    if (content?.user && content.user !== authContext.userProfile.attributes.sub) {
      
      setOwnership(false);
  
      if (content?.share?.SS) {
        
        const isMatching = content.share.SS.some((ss: any) => ss === authContext.userProfile.attributes.sub);
        if (isMatching) {
          
          setControlled(false);
        } else {
          
          setControlled(true);
        }
      } else {
        
        setControlled(true);
      }
    } else {
      
      setControlled(false);
      setOwnership(true);
    }
  }, [content.id, authContext.userProfile.attributes.sub, content.user, content.share?.SS]);
  
  const extractProductCode = (data:any) => {
    const parts = data['product-code']?.split('_') || [];
    if (parts.length < 7) return data;
    return {
      ...data,
      provider: parts[0],
      region: parts[1],
      instanceType: parts[2],
      os: parts[3],
      category: parts[4],
      size: parts[5],
      capacity: parts[6],
    };   
  };

  const qrSrc = useMemo(() => {
    const b64 = content?.qrcode?.value;
    return b64 ? `data:image/png;base64,${b64}` : null;
  }, [content?.qrcode?.value]);

  const downloadQr = () => {
    if (!qrSrc) return;

    const a = document.createElement('a');
    a.href = qrSrc;
    a.download = `${content?.name ?? 'qr-code'}.png`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  // Function to handle control with API call
  const handleControlClick = async (newControlStatus: boolean, prod_id: string) => {
    try {
      
      // Prepare the body for the API request (assuming an object structure)
      const query = {
        id: prod_id,
        body: {
          action: !newControlStatus ? 'ADD' : 'DELETE',
          user: authContext.userProfile.attributes.sub
        }
      };

      const response = await api.setAdminControl(query);

      if (response.status === DEFAULT_API_RESULT.SUCCESS) {
        // If API call succeeds, update the state
        
        setControlled(newControlStatus);
      } else {
        // If the response indicates failure, handle it
        
      }
      getEdgesCallback()
    } catch (error) {
      // Handle any unexpected errors during the API call
      
      getEdgesCallback()
    }
  };

  const handleResetClick = async (prod_id: any) => {
    //helpers.logToOutput('handleResetClick selectedProduct.content.id: ',selectedProduct.content.id)
    helpers.logToOutput('handleResetClick prod_id: ',prod_id)
    try {
      
      // Prepare the body for the API request (assuming an object structure)
      toast.info('Please wait while we reset your product')
      const query = {
        body: {
          id: prod_id
        }
      };

      const response = await api.resetProduct(query);

      if (response.status === DEFAULT_API_RESULT.SUCCESS) {
        // If API call succeeds, update the state
        toast.success('Successfully reset product')
      } else {
        // If the response indicates failure, handle it
        toast.error('Whoops .... something has gone wrong with product reset')
      }
      getEdgesCallback()
    } catch (error) {
      // Handle any unexpected errors during the API call
      
      getEdgesCallback()
    }
  };
  

  return (
    <>
      <Card className='k-overflow-y-scroll-x-hide-nobars k-b-shadow-none ps-0 growable-div k-overflow-a'>
        <Card.Header className='ps-3'>
          <Row>
            <Col className='col-7'>
              <Row>
                <Col className='col-12'>
                  <h4 className='mt-0 mb-0'>{content?.name ?? 'None'}</h4>
                </Col>
              </Row>
              <Row>
                <Col className='col-12 txt-12 color-lightText'>
                  {getUserNameById(content?.user) ?? 'Unknown User'} / {(content?.provider ?? 'None').toUpperCase()} / {variables?.regionToLocationMap?.[content?.region] ?? 'None'}
                </Col>
              </Row>
            </Col>
            {!ownership ? 
              <>
                <Col className='k-align-content-center d-flex justify-content-end'>
                  <Button variant="success" type="submit" 
                    disabled={!controlled} size="sm" className="k-btn"
                    onClick={() => handleControlClick(!controlled, content.id)}>
                      Control
                  </Button>
                </Col>
                <Col className='col-auto k-align-content-center d-flex'>
                  <Button variant="warning" type="submit" 
                    disabled={controlled} size="sm" className="k-btn"
                    onClick={() => handleControlClick(!controlled, content.id)}>
                    Release
                  </Button>
                </Col>
                <Col className='col-auto k-align-content-center d-flex'>
                  <Button variant="info" type="submit" 
                    size="sm" className="k-btn"
                    onClick={() => handleResetClick(content.id)}>
                          Reset
                  </Button>
                </Col>
              </> : 
              <>
                <Col className='k-align-content-center d-flex justify-content-end'>
                  <Button variant="info" type="submit" 
                    size="sm" className="k-btn"
                    onClick={() => handleResetClick(content.id)}>
                          Reset
                  </Button>
                </Col>
              </>
            }
                     
          </Row>
        </Card.Header>
        <Card.Body className='p-0 pt-4'>
          <Row>
            <Col md={6}>
              <Card>
                <Card.Header className='p-2 ps-3 txt-14' ><strong>QR Code</strong></Card.Header>
                <ListGroup variant="flush txt-12">
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'><strong>Created:</strong></Col>
                      <Col className='col-9'>{(helpers.getConditionalDateTime(content?.qrcode?.created, true) ?? 'None').toUpperCase()}</Col> 
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'><strong>One Time:</strong> </Col>
                      <Col className='col-9'>{content?.one_time} </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'><strong>Last Used:</strong> </Col>
                      <Col className='col-9'>{(helpers.getConditionalDateTime(content?.qrcode?.used, true) ?? 'None').toUpperCase()}</Col> 
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'><strong>Code:</strong></Col>
                      <Col className='col-9'>
                        <Button className="k-h-25 k-btn-submit-col txt-14 k-center-content" onClick={() => setShowQr(true)} type="submit">Show Code</Button>
                      </Col>
                    </Row>

                    <Modal show={showQr} onHide={() => setShowQr(false)} centered contentClassName="k-mc-right" dialogClassName="kuro-modal" tabIndex={-1} className="k-modal k-m-right" >
                      <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg'>
                        <Row className='mt-1 k-panel-cent-vert'>
                          <Col className='col-10'>
                            <Modal.Title as="h5" className='p-1'>QR Code</Modal.Title>
                          </Col>
                          <Col className='col-2 k-center-content-hor-right'>
                            <button className='custom-close-button k-pointer' onClick={() => setShowQr(false)} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
                              <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn}></img>
                            </button>
                          </Col>
                        </Row>
                      </Modal.Header>

                      <Modal.Body className="k-modalBody pb-0">
                        {qrSrc ? (
                          <img
                            src={qrSrc}
                            alt="Proxy QR code"
                            style={{ maxWidth: '100%', height: 'auto' }}
                          />
                        ) : (
                          'N/A'
                        )}
                      </Modal.Body>
                      <Modal.Footer>
                        <Button className="k-h-25 k-center-content" variant="secondary" onClick={() => setShowQr(false)}>
                          Close
                        </Button>
                        <Button className="k-h-25 k-center-content" variant="primary" onClick={downloadQr} disabled={!qrSrc}>
                          Download
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </ListGroup.Item>
                </ListGroup>
              </Card>
            </Col>

            <Col md={6}>
              <Card>
                <Card.Header className='p-2 ps-3 txt-14'><strong>Proxy</strong></Card.Header>
                <ListGroup variant="flush txt-12">
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'><strong>Created:</strong></Col>
                      <Col className='col-9'>{content?.ipv4 ?? 'None'}</Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'><strong>DNS:</strong> </Col>
                      <Col className='col-9'>{content?.ipv6 ?? 'None'}</Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'><strong>IPv4:</strong> </Col>
                      <Col className='col-9'>{content?.dns?.domain ?? 'None'}</Col>
                    </Row>
                  </ListGroup.Item>
                </ListGroup>
              </Card>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={12}>
              <Card>
                <Card.Header className='p-2 ps-3 txt-14'><strong>Share Details</strong></Card.Header>
                <ListGroup variant="flush txt-12">
                  {content?.share?.SS ? content.share.SS.map((ss:any, index:any) => (
                    <ListGroup.Item key={index}>
                      <strong>User {index + 1}:</strong> {getUserNameById(ss) ?? 'Unknown User'}
                    </ListGroup.Item>
                  )) : <ListGroup.Item>Product not shared</ListGroup.Item>}
                </ListGroup>
              </Card>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

const AdminEdgeContentFormPaneProxy: React.FunctionComponent<{ edgeContent: types.EdgeContent, getUserNameById: (id: string) => string | null, getEdgesCallback: any }> = 
({ edgeContent, getUserNameById, getEdgesCallback }) => {

  
  const authContext = useContext(authContextHelper.AuthContext);
  const [controlled, setControlled] = useState(true);
  const [ownership, setOwnership] = useState(false);
  const [content, setContent] = useState<any>({});
  const [showQr, setShowQr] = useState(false);

  useEffect(() => {
    //Get Header height
    const header = document.querySelector('#k-app-header') as HTMLElement | null;
    const headerHeight = header ? header.offsetHeight : 0;
    
  
    const layerOne = document.querySelector('#k-adm-dash-l1') as HTMLElement | null;
    const layerOneHeight = layerOne ? layerOne.offsetHeight : 0;
    
  
    const layerTwo = document.querySelector('#k-adm-dash-l2') as HTMLElement | null;
    const layerTwoHeight = layerTwo ? layerTwo.offsetHeight : 0;
    
  
    const layerThree = document.querySelector('#k-adm-dash-l3') as HTMLElement | null;
    const layerThreeHeight = layerThree ? layerThree.offsetHeight : 0;
    
  
    const layerFour = document.querySelector('#k-adm-dash-l4') as HTMLElement | null;
    const layerFourHeight = layerFour ? layerFour.offsetHeight : 0;
    
  
    const layerFive = document.querySelector('#k-adm-dash-l5') as HTMLElement | null;
    const layerFiveHeight = layerFive ? layerFive.offsetHeight : 0;
    
  
    const layerSix = document.querySelector('#k-adm-dash-l6') as HTMLElement | null;
    const layerSixHeight = layerSix ? layerSix.offsetHeight : 0;
    
  
    const footerLayer = document.querySelector('#k-app-footer-le') as HTMLElement | null;
    const footerLayerHeight = footerLayer ? footerLayer.offsetHeight : 0;
    

    const hackHeight = 100;
  
    const totalHeight =
      headerHeight +
      layerOneHeight +
      layerTwoHeight +
      layerThreeHeight +
      layerFourHeight +
      layerFiveHeight +
      layerSixHeight +
      hackHeight;
  
    document.documentElement.style.setProperty('--remaining-height', `calc(100vh - ${totalHeight}px - ${footerLayerHeight}px)`);
  }, []);
  
  useEffect(() => {
    helpers.logToOutput('AdminProductContentFormPane extractProductCode : ',extractProductCode(edgeContent.content));
    setContent(extractProductCode(edgeContent.content));
  }, [edgeContent]);
  
  useEffect(() => {
    if (!content?.id) return; // Check if content.id exists before running the effect

  
    if (content?.user && content.user !== authContext.userProfile.attributes.sub) {
      
      setOwnership(false);
  
      if (content?.share?.SS) {
        
        const isMatching = content.share.SS.some((ss: any) => ss === authContext.userProfile.attributes.sub);
        if (isMatching) {
          
          setControlled(false);
        } else {
          
          setControlled(true);
        }
      } else {
        
        setControlled(true);
      }
    } else {
      
      setControlled(false);
      setOwnership(true);
    }
  }, [content.id, authContext.userProfile.attributes.sub, content.user, content.share?.SS]);
  
  const extractProductCode = (data:any) => {
    const parts = data['product-code']?.split('_') || [];
    if (parts.length < 7) return data;
    return {
      ...data,
      provider: parts[0],
      region: parts[1],
      instanceType: parts[2],
      os: parts[3],
      category: parts[4],
      size: parts[5],
      capacity: parts[6],
    };   
  };

  const qrSrc = useMemo(() => {
    const b64 = content?.qrcode?.value;
    return b64 ? `data:image/png;base64,${b64}` : null;
  }, [content?.qrcode?.value]);

  const downloadQr = () => {
    if (!qrSrc) return;

    const a = document.createElement('a');
    a.href = qrSrc;
    a.download = `${content?.name ?? 'qr-code'}.png`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  // Function to handle control with API call
  const handleControlClick = async (newControlStatus: boolean, prod_id: string) => {
    try {
      
      // Prepare the body for the API request (assuming an object structure)
      const query = {
        id: prod_id,
        body: {
          action: !newControlStatus ? 'ADD' : 'DELETE',
          user: authContext.userProfile.attributes.sub
        }
      };

      const response = await api.setAdminControl(query);

      if (response.status === DEFAULT_API_RESULT.SUCCESS) {
        // If API call succeeds, update the state
        
        setControlled(newControlStatus);
      } else {
        // If the response indicates failure, handle it
        
      }
      getEdgesCallback()
    } catch (error) {
      // Handle any unexpected errors during the API call
      
      getEdgesCallback()
    }
  };

  const handleResetClick = async (prod_id: any) => {
    //helpers.logToOutput('handleResetClick selectedProduct.content.id: ',selectedProduct.content.id)
    helpers.logToOutput('handleResetClick prod_id: ',prod_id)
    try {
      
      // Prepare the body for the API request (assuming an object structure)
      toast.info('Please wait while we reset your product')
      const query = {
        body: {
          id: prod_id
        }
      };

      const response = await api.resetProduct(query);

      if (response.status === DEFAULT_API_RESULT.SUCCESS) {
        // If API call succeeds, update the state
        toast.success('Successfully reset product')
      } else {
        // If the response indicates failure, handle it
        toast.error('Whoops .... something has gone wrong with product reset')
      }
      getEdgesCallback()
    } catch (error) {
      // Handle any unexpected errors during the API call
      
      getEdgesCallback()
    }
  };
  

  return (
    <>
      <Card className='k-overflow-y-scroll-x-hide-nobars k-b-shadow-none ps-0 growable-div k-overflow-a'>
        <Card.Header className='ps-3'>
          <Row>
            <Col className='col-7'>
              <Row>
                <Col className='col-12'>
                  <h4 className='mt-0 mb-0'>{content?.name ?? 'None'} Proxy</h4>
                </Col>
              </Row>
              <Row>
                <Col className='col-12 txt-12 color-lightText'>
                  {getUserNameById(content?.user) ?? 'Unknown User'} / {(content?.provider ?? 'None').toUpperCase()} / {variables?.regionToLocationMap?.[content?.region] ?? 'None'}
                </Col>
              </Row>
            </Col>
            {!ownership ? 
              <>
                <Col className='k-align-content-center d-flex justify-content-end'>
                  <Button variant="success" type="submit" 
                    disabled={!controlled} size="sm" className="k-btn"
                    onClick={() => handleControlClick(!controlled, content.id)}>
                      Control
                  </Button>
                </Col>
                <Col className='col-auto k-align-content-center d-flex'>
                  <Button variant="warning" type="submit" 
                    disabled={controlled} size="sm" className="k-btn"
                    onClick={() => handleControlClick(!controlled, content.id)}>
                    Release
                  </Button>
                </Col>
                <Col className='col-auto k-align-content-center d-flex'>
                  <Button variant="info" type="submit" 
                    size="sm" className="k-btn"
                    onClick={() => handleResetClick(content.id)}>
                          Reset
                  </Button>
                </Col>
              </> : 
              <>
                <Col className='k-align-content-center d-flex justify-content-end'>
                  <Button variant="info" type="submit" 
                    size="sm" className="k-btn"
                    onClick={() => handleResetClick(content.id)}>
                          Reset
                  </Button>
                </Col>
              </>
            }
                     
          </Row>
        </Card.Header>
        <Card.Body className='p-0 pt-4'>
          <Row>
            <Col md={6}>
              <Card>
                <Card.Header className='p-2 ps-3 txt-14' ><strong>QR Code</strong></Card.Header>
                <ListGroup variant="flush txt-12">
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'><strong>Created:</strong></Col>
                      <Col className='col-9'>{(helpers.getConditionalDateTime(content?.qrcode?.created, true) ?? 'None').toUpperCase()}</Col> 
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'><strong>One Time:</strong> </Col>
                      <Col className='col-9'>{content?.one_time} </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'><strong>Last Used:</strong> </Col>
                      <Col className='col-9'>{(helpers.getConditionalDateTime(content?.qrcode?.used, true) ?? 'None').toUpperCase()}</Col> 
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'><strong>Code:</strong></Col>
                      <Col className='col-9'>
                        <Button className="k-h-25 k-btn-submit-col txt-14 k-center-content" onClick={() => setShowQr(true)} type="submit">Show Code</Button>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                </ListGroup>
              </Card>
            </Col>

            <Col md={6}>
              <Card>
                <Card.Header className='p-2 ps-3 txt-14'><strong>Proxy</strong></Card.Header>
                <ListGroup variant="flush txt-12">
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'><strong>Created:</strong></Col>
                      <Col className='col-9'>{content?.ipv4 ?? 'None'}</Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'><strong>DNS:</strong> </Col>
                      <Col className='col-9'>{content?.ipv6 ?? 'None'}</Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'><strong>IPv4:</strong> </Col>
                      <Col className='col-9'>{content?.dns?.domain ?? 'None'}</Col>
                    </Row>
                  </ListGroup.Item>
                </ListGroup>
              </Card>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={12}>
              <Card>
                <Card.Header className='p-2 ps-3 txt-14'><strong>Share Details</strong></Card.Header>
                <ListGroup variant="flush txt-12">
                  {content?.share?.SS ? content.share.SS.map((ss:any, index:any) => (
                    <ListGroup.Item key={index}>
                      <strong>User {index + 1}:</strong> {getUserNameById(ss) ?? 'Unknown User'}
                    </ListGroup.Item>
                  )) : <ListGroup.Item>Product not shared</ListGroup.Item>}
                </ListGroup>
              </Card>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

const AdminEdgeContentFormPaneEndpoint: React.FunctionComponent<{ edgeContent: types.EdgeContent, getUserNameById: (id: string) => string | null, getEdgesCallback: any }> = 
({ edgeContent, getUserNameById, getEdgesCallback }) => {

  
  const authContext = useContext(authContextHelper.AuthContext);
  const [controlled, setControlled] = useState(true);
  const [ownership, setOwnership] = useState(false);
  const [content, setContent] = useState<any>({});
  const [showQr, setShowQr] = useState(false);

  useEffect(() => {
    //Get Header height
    const header = document.querySelector('#k-app-header') as HTMLElement | null;
    const headerHeight = header ? header.offsetHeight : 0;
    
  
    const layerOne = document.querySelector('#k-adm-dash-l1') as HTMLElement | null;
    const layerOneHeight = layerOne ? layerOne.offsetHeight : 0;
    
  
    const layerTwo = document.querySelector('#k-adm-dash-l2') as HTMLElement | null;
    const layerTwoHeight = layerTwo ? layerTwo.offsetHeight : 0;
    
  
    const layerThree = document.querySelector('#k-adm-dash-l3') as HTMLElement | null;
    const layerThreeHeight = layerThree ? layerThree.offsetHeight : 0;
    
  
    const layerFour = document.querySelector('#k-adm-dash-l4') as HTMLElement | null;
    const layerFourHeight = layerFour ? layerFour.offsetHeight : 0;
    
  
    const layerFive = document.querySelector('#k-adm-dash-l5') as HTMLElement | null;
    const layerFiveHeight = layerFive ? layerFive.offsetHeight : 0;
    
  
    const layerSix = document.querySelector('#k-adm-dash-l6') as HTMLElement | null;
    const layerSixHeight = layerSix ? layerSix.offsetHeight : 0;
    
  
    const footerLayer = document.querySelector('#k-app-footer-le') as HTMLElement | null;
    const footerLayerHeight = footerLayer ? footerLayer.offsetHeight : 0;
    

    const hackHeight = 100;
  
    const totalHeight =
      headerHeight +
      layerOneHeight +
      layerTwoHeight +
      layerThreeHeight +
      layerFourHeight +
      layerFiveHeight +
      layerSixHeight +
      hackHeight;
  
    document.documentElement.style.setProperty('--remaining-height', `calc(100vh - ${totalHeight}px - ${footerLayerHeight}px)`);
  }, []);
  
  useEffect(() => {
    helpers.logToOutput('AdminProductContentFormPane extractProductCode : ',extractProductCode(edgeContent.content));
    setContent(extractProductCode(edgeContent.content));
  }, [edgeContent]);
  
  useEffect(() => {
    if (!content?.id) return; // Check if content.id exists before running the effect

  
    if (content?.user && content.user !== authContext.userProfile.attributes.sub) {
      
      setOwnership(false);
  
      if (content?.share?.SS) {
        
        const isMatching = content.share.SS.some((ss: any) => ss === authContext.userProfile.attributes.sub);
        if (isMatching) {
          
          setControlled(false);
        } else {
          
          setControlled(true);
        }
      } else {
        
        setControlled(true);
      }
    } else {
      
      setControlled(false);
      setOwnership(true);
    }
  }, [content.id, authContext.userProfile.attributes.sub, content.user, content.share?.SS]);
  
  const extractProductCode = (data:any) => {
    const parts = data['product-code']?.split('_') || [];
    if (parts.length < 7) return data;
    return {
      ...data,
      provider: parts[0],
      region: parts[1],
      instanceType: parts[2],
      os: parts[3],
      category: parts[4],
      size: parts[5],
      capacity: parts[6],
    };   
  };

  const qrSrc = useMemo(() => {
    const b64 = content?.qrcode?.value;
    return b64 ? `data:image/png;base64,${b64}` : null;
  }, [content?.qrcode?.value]);

  const downloadQr = () => {
    if (!qrSrc) return;

    const a = document.createElement('a');
    a.href = qrSrc;
    a.download = `${content?.name ?? 'qr-code'}.png`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  // Function to handle control with API call
  const handleControlClick = async (newControlStatus: boolean, prod_id: string) => {
    try {
      
      // Prepare the body for the API request (assuming an object structure)
      const query = {
        id: prod_id,
        body: {
          action: !newControlStatus ? 'ADD' : 'DELETE',
          user: authContext.userProfile.attributes.sub
        }
      };

      const response = await api.setAdminControl(query);

      if (response.status === DEFAULT_API_RESULT.SUCCESS) {
        // If API call succeeds, update the state
        
        setControlled(newControlStatus);
      } else {
        // If the response indicates failure, handle it
        
      }
      getEdgesCallback()
    } catch (error) {
      // Handle any unexpected errors during the API call
      
      getEdgesCallback()
    }
  };

  const handleResetClick = async (prod_id: any) => {
    //helpers.logToOutput('handleResetClick selectedProduct.content.id: ',selectedProduct.content.id)
    helpers.logToOutput('handleResetClick prod_id: ',prod_id)
    try {
      
      // Prepare the body for the API request (assuming an object structure)
      toast.info('Please wait while we reset your product')
      const query = {
        body: {
          id: prod_id
        }
      };

      const response = await api.resetProduct(query);

      if (response.status === DEFAULT_API_RESULT.SUCCESS) {
        // If API call succeeds, update the state
        toast.success('Successfully reset product')
      } else {
        // If the response indicates failure, handle it
        toast.error('Whoops .... something has gone wrong with product reset')
      }
      getEdgesCallback()
    } catch (error) {
      // Handle any unexpected errors during the API call
      
      getEdgesCallback()
    }
  };
  

  return (
    <>
      <Card className='k-overflow-y-scroll-x-hide-nobars k-b-shadow-none ps-0 growable-div k-overflow-a'>
        <Card.Header className='ps-3'>
          <Row>
            <Col className='col-7'>
              <Row>
                <Col className='col-12'>
                  <h4 className='mt-0 mb-0'>{content?.endpoint?.['device-make'] ?? 'Unknown'} Endpoint</h4>
                </Col>
              </Row>
              <Row>
                <Col className='col-12 txt-12 color-lightText'>
                  {(content?.endpoint?.['device-model'] ?? 'None').toUpperCase()} / {content?.endpoint?.lat ?? 'None'}, {content?.endpoint?.long ?? 'None'}
                </Col>
              </Row>
            </Col>
            <Col className='col-auto k-align-content-center d-flex'>
              <Button variant="info" type="submit" 
                size="sm" className="k-btn"
                onClick={() => handleResetClick(content.id)}>
                      Erase
              </Button>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body className='p-0 pt-4'>
          <Row>
            <Col md={6}>
              <Card>
                <Card.Header className='p-2 ps-3 txt-14' ><strong>QR Code</strong></Card.Header>
                <ListGroup variant="flush txt-12">
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'><strong>Created:</strong></Col>
                      <Col className='col-9'>{(helpers.getConditionalDateTime(content?.qrcode?.created, true) ?? 'None').toUpperCase()}</Col> 
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'><strong>One Time:</strong> </Col>
                      <Col className='col-9'>{content?.one_time} </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'><strong>Last Used:</strong> </Col>
                      <Col className='col-9'>{(helpers.getConditionalDateTime(content?.qrcode?.used, true) ?? 'None').toUpperCase()}</Col> 
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-3'><strong>Code:</strong></Col>
                      <Col className='col-9'>
                        <Button className="k-h-25 k-btn-submit-col txt-14 k-center-content" onClick={() => setShowQr(true)} type="submit">Show Code</Button>
                      </Col>
                    </Row>

                    <Modal show={showQr} onHide={() => setShowQr(false)} centered contentClassName="k-mc-right" dialogClassName="kuro-modal" tabIndex={-1} className="k-modal k-m-right" >
                      <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg'>
                        <Row className='mt-1 k-panel-cent-vert'>
                          <Col className='col-10'>
                            <Modal.Title as="h5" className='p-1'>QR Code</Modal.Title>
                          </Col>
                          <Col className='col-2 k-center-content-hor-right'>
                            <button className='custom-close-button k-pointer' onClick={() => setShowQr(false)} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
                              <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn}></img>
                            </button>
                          </Col>
                        </Row>
                      </Modal.Header>

                      <Modal.Body className="k-modalBody pb-0">
                        {qrSrc ? (
                          <img
                            src={qrSrc}
                            alt="Proxy QR code"
                            style={{ maxWidth: '100%', height: 'auto' }}
                          />
                        ) : (
                          'N/A'
                        )}
                      </Modal.Body>
                      <Modal.Footer>
                        <Button className="k-h-25 k-center-content" variant="secondary" onClick={() => setShowQr(false)}>
                          Close
                        </Button>
                        <Button className="k-h-25 k-center-content" variant="primary" onClick={downloadQr} disabled={!qrSrc}>
                          Download
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </ListGroup.Item>
                </ListGroup>
              </Card>
            </Col>

            <Col md={6}>
              <Card>
                <Card.Header className='p-2 ps-3 txt-14'><strong>Proxy</strong></Card.Header>
                <ListGroup variant="flush txt-12">
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-2'><strong>Created:</strong></Col>
                      <Col className='col-10'>{content?.ipv4 ?? 'None'}</Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-2'><strong>DNS:</strong> </Col>
                      <Col className='col-10'>{content?.ipv6 ?? 'None'}</Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col className='col-2'><strong>IPv4:</strong> </Col>
                      <Col className='col-10'>{content?.dns?.domain ?? 'None'}</Col>
                    </Row>
                  </ListGroup.Item>
                </ListGroup>
              </Card>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={12}>
              <Card>
                <Card.Header className='p-2 ps-3 txt-14'><strong>Share Details</strong></Card.Header>
                <ListGroup variant="flush txt-12">
                  {content?.share?.SS ? content.share.SS.map((ss:any, index:any) => (
                    <ListGroup.Item key={index}>
                      <strong>User {index + 1}:</strong> {getUserNameById(ss) ?? 'Unknown User'}
                    </ListGroup.Item>
                  )) : <ListGroup.Item>Product not shared</ListGroup.Item>}
                </ListGroup>
              </Card>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export const AdminGeneralPlatformContentTab: React.FunctionComponent<any> = (props:any) => {
  const { 
    config,
  } = props;


  const [containerHeight, setContainerHeight] = useState<number>(250); // Default height
  const [isLoading, setLoading] = useState(false);
  const [vpnDetails, setVpnDetails] = useState<types.VpnCredentialsMap>(
    () => new Map<number, [string, string]>()
  );

  const [maskStates, setMaskStates] = useState<boolean[]>([true, true, true, true, true, true]);
  const toggleMaskState = (index: number) => {
    setMaskStates((prev) => {
      const next = [...prev];
      next[index] = !next[index];
      return next;
    });
  };

  const [settings, setSettings] = useState<types.DeploymentSettings>(config);
  
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    const { name, value, type, checked } = e.target as HTMLInputElement;
    // If it's a checkbox or switch:
    if (type === 'checkbox') {
      setSettings((prev) => ({ ...prev, [name]: checked }));
    } else {
      setSettings((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setSettings((prev) => ({
      ...prev,
      [name]: parseInt(value, 10)
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Perform any actions you need here, e.g., calling an API or storing the settings
    helpers.logToOutput('Updated Settings:', settings);
    updateSettings();
  };

  const handleSuperSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Perform any actions you need here, e.g., calling an API or storing the settings
    helpers.logToOutput('Updated Super Settings:', settings);
    updateSuperSettings();
  };

  const handleVPNChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
    index: number
  ) => {
    const { name, value } = e.target;
    // We must create a new Map so that React sees the change.
    setVpnDetails((prev) => {
      const newMap = new Map(prev);

      // Either get existing credentials or default to ['', '']
      const existingCredentials = newMap.get(index) ?? ['', ''];
      if (name === 'username') {
        existingCredentials[0] = value;
      } else if (name === 'password') {
        existingCredentials[1] = value;
      }
      newMap.set(index, existingCredentials);

      return newMap;
    });
  };

  const handleVPNSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
  
    try {
      // Always produce exactly 6 entries
      const formattedVpnAccounts = [1, 2, 3, 4, 5, 6].map((key) => {
        const [u, p] = vpnDetails.get(key) ?? ['', ''];
        return {
          name: key,         // or however your API expects to identify each account
          username: u,
          password: p,
        };
      });
  
      // For example, call adminPutVPNDetails like so:
      const response = await api.adminPutVPNDetails({
        body: {
          vpn_details: formattedVpnAccounts,
        },
      });
      helpers.logToOutput('VPN response:', response);
      toast.success('VPN settings updated');
    } catch (error) {
      helpers.logToOutput('Error saving VPN credentials:', error);
      toast.error('Error: VPN settings not updated');
    } finally {
      setLoading(false);
    }
  };
  
  // Function to update the container height based on window size
  const updateHeight = () => {
    const windowHeight = window.innerHeight;
    const newHeight = windowHeight - 290; // Minus the top and bottom banners etc...
    setContainerHeight(newHeight);
  };

  useEffect(() => {

    const fetchVpnDetails = async () => {
      try {
        const apiResponse = await api.adminGetVPNDetails(null);
        helpers.logToOutput('VPN apiResponse:', apiResponse);
        
        if (apiResponse.status === DEFAULT_API_RESULT.SUCCESS) {
          // The response body should be an array of objects (e.g. [{ name, username, password }, ...])
          const data = apiResponse.body as types.IVpnItem[];
          helpers.logToOutput('VPN apiResponse.body:', data);
          
          // Create a new Map and populate it
          const newMap = new Map<number, [string, string]>();
          data.forEach((item) => {
            const nameAsNumber = parseInt(item.name, 10);
            newMap.set(nameAsNumber, [item.username, item.password]);
          });
          
          // Update state
          setVpnDetails(newMap);
        } else {
          // If needed, handle the case where the response status isn't SUCCESS
          helpers.logToOutput('Failed to retrieve VPN details:', apiResponse.errorMessage);
        }
      } catch (error) {
        helpers.logToOutput('Error fetching VPN details:', error);
      }
    };

    updateHeight(); // Set initial height
    window.addEventListener('resize', updateHeight);

    fetchVpnDetails();

    // Cleanup on component unmount
    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);

  const updateSettings = async () => {
    setLoading(true);

    const adminSettings = [
      'AUTO_HIBERNATE',
      'SEARCH',
      'ENFORCE_SCREEN',
      'DEFAULT_SCREEN_W',
      'DEFAULT_SCREEN_H',
      'DEFAULT_HIBERNATION_TIME',
      'BRANDING',
      'ENABLE_USERNAME',
      'ENABLE_NUMBER',
      'GROUPS',
      'SECURE_CP',
      'DEFAULT_AVD_NUMBER',
      'AVDEVICE',
      'WINDESKTOP',
      'UBUNDESKTOP',
    ] as const;

    const filteredSettings = adminSettings.reduce((acc, key) => {
      acc[key] = settings[key];
      return acc;
    }, {} as Record<typeof adminSettings[number], string | number | boolean>);

    const bodyToSend = {
      ...filteredSettings
    };
    
    toast.info('Please wait while we update the configuration details')
    const putResponse = await api.setConfiguration({
      body: bodyToSend,
    });

    if (putResponse?.status === 200) {
      
      toast.success('Settings updated');
      setLoading(false);

    } else {
      
      toast.warn('Sorry something has gone wrong, please try again or contact the support desk')
      setLoading(false);
    }
  };

  const updateSuperSettings = async () => {
    setLoading(true);

    const adminSuperSettings = [
      'ENVIRONMENT',
      'SUPPORT',
      'FILE_EXPLORER',
      'REFERENCE',
      'VPN',
      'KAI',
      'VNUMBER'
    ] as const;

    const filteredSettings = adminSuperSettings.reduce((acc, key) => {
      acc[key] = settings[key];
      return acc;
    }, {} as Record<typeof adminSuperSettings[number], string | number | boolean>);

    const bodyToSend = {
      ...filteredSettings
    };
    
    toast.info('Please wait while we update the configuration details')
    const putResponse = await api.setConfiguration({
      body: bodyToSend,
    });

    if (putResponse?.status === 200) {
      
      toast.success('Settings updated');
      setLoading(false);

    } else {
      
      toast.warn('Sorry something has gone wrong, please try again or contact the support desk')
      setLoading(false);
    }
  };

  const handleBrandingDropdownChange = (value: string) => {
    setSettings(prev => ({ ...prev, BRANDING: value }));
  };

  const handleEnvironmentDropdownChange = (value: string) => {
    setSettings(prev => ({ ...prev, ENVIRONMENT: value }));
  };

  const handleSupportDropdownChange = (value: string) => {
    setSettings(prev => ({ ...prev, SUPPORT: value }));
  };


  return (
    <>
      <Row className=''>
        <Col className='col-12'>
          <Row className='m-0'>
            <Col className="">
              <Row className='m-0 p-0'><Col className='m-0 p-0'> <span className='txt-17'>General Settings</span></Col></Row>
              <Row className='m-0 p-0'><Col className='m-0 p-0'> <span className='txt-12'>Modify settings your organisation</span></Col></Row>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className='mt-2'>
        <Col className="col-12">
          <Row className="m-0 mt-2">
            <Col className="col-12">
              <Tab.Container id="profile-content-pane" defaultActiveKey="admin.GeneralSettings">
                <Row id="k-adm-dash-l5" className='m-0 p-0 mt-1'>
                  <Nav className="pb-1">
                    <Nav.Item className="">
                      <Nav.Link eventKey="admin.GeneralSettings" className="p-0 txt-12">
                        General
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="ms-3">
                      <Nav.Link eventKey="admin.DesktopSettings" className="p-0 txt-12">
                        Desktop
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="ms-3">
                      <Nav.Link eventKey="admin.AndroidSettings" className="p-0 txt-12">
                        Android
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="ms-3">
                      <Nav.Link eventKey="admin.VpnSettings" className="p-0 txt-12">
                        VPN
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="ms-3">
                      <Nav.Link eventKey="admin.AdvancedSettings" className="p-0 txt-12">
                        Advanced
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Row>
                <hr id="k-adm-dash-l6" className='k-border-top-black mt-0 mb-0'></hr>
                <Row className="mt-0 pe-0 m-0 ">
                  <Tab.Content className='mt-0 pt-1 k-fg-1 k-of-y-auto'>
                    <Tab.Pane eventKey="admin.GeneralSettings">
                      <div className="k-overflow-y-scroll" style={{ height: `${containerHeight}px` }}>
                        <Row>
                          <Col className="col-12 p-0 ">
                            <Row className="m-0 mt-2">
                              <Col className="col-12">
                                <Container className="mb-4 mx-0">
                                  <Form onSubmit={handleSubmit}>
                                    <Row className="mb-3">
                                      <Col md={6}>
                                        <div className='mb-3'>
                                          <span className="p-0 txt-12 txt-light" >
                                            This page allows you to personalise your experience on our online platform. 
                                            Adjust your preferences, update your account details and manage important settings to ensure the service meets your needs. 
                                            Please explore the options below to tailor the platform just the way you like it.
                                          </span>
                                        </div>
                                        <span className="p-0 txt-14 txt-weight-900">Platform Settings</span>
                                        <hr id="k-adm-dash-l6" className='k-border-top-black mt-0 mb-2'></hr>
                                        <Form.Group controlId="branding" className="mb-3">
                                          <Form.Label>
                                            <span className="p-0 txt-12 txt-weight-500">Branding</span><span className="p-0 txt-12 txt-weight-200"> - choose a branding option from the list below</span>
                                          </Form.Label>

                                          <Dropdown>
                                            <Dropdown.Toggle variant="secondary" id="branding-dropdown" className='k-bg-trans color-DA k-p-8 k-wh-100pc k-dropdown-toggle'>
                                              {settings.BRANDING || 'Select your branding'}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                              <Dropdown.Item
                                                eventKey="KURO"
                                                onClick={() => handleBrandingDropdownChange('KURO')}
                                              >
                                                KURO
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                eventKey="GENERIC"
                                                onClick={() => handleBrandingDropdownChange('GENERIC')}
                                              >
                                                GENERIC
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                eventKey="NONE"
                                                onClick={() => handleBrandingDropdownChange('NONE')}
                                              >
                                                NONE
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </Form.Group>
                                        <div>
                                          <span className="p-0 txt-12 txt-weight-500">Search</span><span className="p-0 txt-12 txt-weight-200"> - enable or disable the search facility on the front page</span>
                                        </div>
                                        <Form.Check 
                                          type="switch"
                                          id="search"
                                          label="Search"
                                          name="SEARCH"
                                          checked={settings.SEARCH}
                                          onChange={handleInputChange}
                                          className="mb-2"
                                        />

                                        <div>
                                          <span className="p-0 txt-12 txt-weight-500">Groups</span>
                                          <span className="p-0 txt-12 txt-weight-200"> - allow administrators to create and manage groups</span>
                                        </div>
                                        <Form.Check 
                                          type="switch"
                                          id="enableGroups"
                                          label="Groups"
                                          name="GROUPS"
                                          checked={settings.GROUPS}
                                          onChange={handleInputChange}
                                          className="mb-2"
                                        />
                                        
                                      </Col>
                                    </Row>
                                    <Button variant="primary" type="submit">
                                    Save Changes
                                    </Button>
                                  </Form>
                                </Container>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="admin.DesktopSettings">
                      <div className="k-overflow-y-scroll" style={{ height: `${containerHeight}px` }}>
                        <Row>
                          <Col className="col-12 p-0 ">
                            <Row className="m-0 mt-2">
                              <Col className="col-12">
                                <Container className="mb-4 mx-0">
                                  <Form onSubmit={handleSubmit}>
                                    <Row className="mb-3">
                                      <Col md={6}>
                                        <div className='mb-3'>
                                          <span className="p-0 txt-12 txt-light" >
                                            This page allows you to personalise your desktop settings on the platform. 
                                            Please explore the options below to tailor the platform just the way you like it.
                                          </span>
                                        </div>

                                        <span className="p-0 txt-14 txt-weight-900">Desktop Settings</span>
                                        <hr id="k-adm-dash-l6" className='k-border-top-black mt-0 mb-2'></hr>


                                        <div>
                                          <span className="p-0 txt-12 txt-weight-500">Desktops</span>
                                          <span className="p-0 txt-12 txt-weight-200"> - enable or disable desktop types</span>
                                        </div>
                                        <Form.Check 
                                          inline
                                          type="switch"
                                          id="enableWindowsD"
                                          label="Windows"
                                          name="WINDESKTOP"
                                          checked={settings.WINDESKTOP}
                                          onChange={handleInputChange}
                                          className="mb-3"
                                        />

                                        <Form.Check 
                                          inline
                                          type="switch"
                                          id="enableUbuntuD"
                                          label="Ubuntu"
                                          name="UBUNDESKTOP"
                                          checked={settings.UBUNDESKTOP}
                                          onChange={handleInputChange}
                                          className="mb-3"
                                        />

                                        <div>
                                          <span className="p-0 txt-12 txt-weight-500">Username Settings</span>
                                          <span className="p-0 txt-12 txt-weight-200"> - allow users to set their own username</span>
                                        </div>
                                        <Form.Check 
                                          type="switch"
                                          id="enableUsername"
                                          label="Custom Username"
                                          name="ENABLE_USERNAME"
                                          checked={settings.ENABLE_USERNAME}
                                          onChange={handleInputChange}
                                          className="mb-3"
                                        />

                                        {/*<div>
                                          <span className="p-0 txt-12 txt-weight-500">Desktop Locations</span>
                                          <span className="p-0 txt-12 txt-weight-200"> - select the locations to deploy desktops into</span>
                                        </div>
                                        <Row>
                                          <p className="mb-0 mt-2">
                                            <Row>
                                              <Col className='col-9'>
                                                <MultiSelect
                                                  options={locations}
                                                  value={locationsSelected}
                                                  onChange={setLocationsSelected}
                                                  valueRenderer={valueRenderer}
                                                  hasSelectAll={true}
                                                  labelledBy="Select"
                                                  className='mb-3'
                                                />
                                              </Col>
                                            </Row>
                                          </p>
                                        </Row>*/}

                                        <div>
                                          <span className="p-0 txt-12 txt-weight-500">Hibernation </span> 
                                          <span className="p-0 txt-12 txt-weight-200"> - enable auto hibernation override</span>
                                        </div>
                                        <Form.Check 
                                          type="switch"
                                          id="autoHibernate"
                                          label="Auto Hibernate Override"
                                          name="AUTO_HIBERNATE"
                                          checked={settings.AUTO_HIBERNATE}
                                          onChange={handleInputChange}
                                          className="mb-3"
                                        />

                                        <div>
                                          <span className="p-0 txt-12 txt-weight-500">Secure Paste </span> 
                                          <span className="p-0 txt-12 txt-weight-200"> - enable out of band paste</span>
                                        </div>
                                        <Form.Check 
                                          type="switch"
                                          id="secureCP"
                                          label="Secure Paste"
                                          name="SECURE_CP"
                                          checked={settings.SECURE_CP}
                                          onChange={handleInputChange}
                                          className="mb-4"
                                        />

                                        <div>
                                          <span className="p-0 txt-12 txt-weight-500">Screen Size</span><span className="p-0 txt-12 txt-weight-200"> - enforce a specific screen size for all users</span>
                                        </div>
                                        <Form.Check 
                                          type="switch"
                                          id="enforceScreen"
                                          label="Enforce Screen Size"
                                          name="ENFORCE_SCREEN"
                                          checked={settings.ENFORCE_SCREEN}
                                          onChange={handleInputChange}
                                          className="mb-2"
                                        />

                                        <Form.Group controlId="defaultScreenW" className="mb-3 k-ps-2-5rem">
                                          <Form.Label>
                                            <span className={settings.ENFORCE_SCREEN ? 'p-0 txt-12 txt-weight-500' : 'p-0 txt-12 txt-weight-500 color-lightText'}>Default Screen Width</span><br/>
                                            <span className={settings.ENFORCE_SCREEN ? 'p-0 txt-12 txt-weight-200' : 'p-0 txt-12 txt-weight-200 color-lightText'}>Specify in pixels the width of the display</span>
                                          </Form.Label>
                                          <Form.Control
                                            className={settings.ENFORCE_SCREEN ? '' : 'color-lightText'}
                                            type="number"
                                            name="DEFAULT_SCREEN_W"
                                            value={settings.DEFAULT_SCREEN_W}
                                            onChange={handleNumberChange}
                                            disabled={!settings.ENFORCE_SCREEN} // Disable if ENFORCE_SCREEN is false
                                          />
                                        </Form.Group>

                                        <Form.Group controlId="defaultScreenH" className="mb-3 k-ps-2-5rem">
                                          <Form.Label>
                                            <span className={settings.ENFORCE_SCREEN ? 'p-0 txt-12 txt-weight-500' : 'p-0 txt-12 txt-weight-500 color-lightText'}>Default Screen Height</span><br/>
                                            <span className={settings.ENFORCE_SCREEN ? 'p-0 txt-12 txt-weight-200' : 'p-0 txt-12 txt-weight-200 color-lightText'}>Specify in pixels the height of the display</span>
                                          </Form.Label>
                                          <Form.Control
                                            className={settings.ENFORCE_SCREEN ? '' : 'color-lightText'}
                                            type="number"
                                            name="DEFAULT_SCREEN_H"
                                            value={settings.DEFAULT_SCREEN_H}
                                            onChange={handleNumberChange}
                                            disabled={!settings.ENFORCE_SCREEN} // Disable if ENFORCE_SCREEN is false
                                          />
                                        </Form.Group>
                                      </Col>
                                    </Row>
                                    <Button variant="primary" type="submit">
                                    Save Changes
                                    </Button>
                                  </Form>
                                </Container>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="admin.AndroidSettings">
                      <div className="k-overflow-y-scroll" style={{ height: `${containerHeight}px` }}>
                        <Row>
                          <Col className="col-12 p-0 ">
                            <Row className="m-0 mt-2">
                              <Col className="col-12">
                                <Container className="mb-4 mx-0">
                                  <Form onSubmit={handleSubmit}>
                                    <Row className="mb-3">
                                      <Col md={6}>
                                        <div className='mb-3'>
                                          <span className="p-0 txt-12 txt-light" >
                                            This page allows you to personalise your Android experience on the platform. 
                                            Please explore the options below to tailor the platform just the way you like it.
                                          </span>
                                        </div>

                                        <span className="p-0 txt-14 txt-weight-900">Android Settings</span>
                                        <hr id="k-adm-dash-l6" className='k-border-top-black mt-0 mb-2'></hr>


                                        <div>
                                          <span className="p-0 txt-12 txt-weight-500">Android Devices</span>
                                          <span className="p-0 txt-12 txt-weight-200"> - enable Android devices</span>
                                        </div>
                                        <Form.Check 
                                          type="switch"
                                          id="enableAndroidD"
                                          label="Android Devices"
                                          name="AVDEVICE"
                                          checked={settings.AVDEVICE}
                                          onChange={handleInputChange}
                                          className="mb-4"
                                        />

                                        <div>
                                          <span className="p-0 txt-12 txt-weight-500">Mobile Numbers</span>
                                          <span className="p-0 txt-12 txt-weight-200"> - enable number assignment on build</span>
                                        </div>
                                        <Form.Check 
                                          type="switch"
                                          id="enableAndroidNumber"
                                          label="Number on build"
                                          name="ENABLE_NUMBER"
                                          checked={settings.ENABLE_NUMBER}
                                          onChange={handleInputChange}
                                          className="mb-4"
                                        />
                                        
                                      </Col>
                                    </Row>
                                    <Button variant="primary" type="submit">
                                    Save Changes
                                    </Button>
                                  </Form>
                                </Container>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="admin.VpnSettings">
                      <div className="k-overflow-y-scroll" style={{ height: `${containerHeight}px` }}>
                        <Row>
                          <Col className="col-12 p-0">
                            <Row className="m-0 mt-2">
                              <Col className="col-12">
                                <Container className="mb-4 mx-0">
                                  <Form onSubmit={handleVPNSubmit}>
                                    <Row className="mb-3">
                                      <Col md={6}>
                                        <div className="mb-3">
                                          <span className="p-0 txt-12 txt-light">
                                            This page allows you to personalise the VPN settings on the platform.
                                            Please explore the options below to add credentials to the platform.
                                          </span>
                                        </div>
                                        <span className="p-0 txt-14 txt-weight-900">VPN Settings</span>
                                        <hr id="k-adm-dash-l6" className="k-border-top-black mt-0 mb-2" />
                                        <Form.Group controlId="defaultVPNSettings" className="mb-3">
                                          <Form.Label>
                                            <span className="p-0 txt-12 txt-weight-500">OpenVPN Credentials</span>
                                            <br />
                                            <span className="p-0 txt-12 txt-weight-200">
                                              Please enter the OpenVPN (IKEv2) username and password in the boxes below. 
                                              You can have up to six accounts, and the system will cycle through each one 
                                              as it provisions a VPN to each user.
                                            </span>
                                          </Form.Label>
                                          {/* Row 1 */}
                                          <Row>
                                            <Col className="col-6">
                                              <Form.Control
                                                id="uname1"
                                                type="text"
                                                name="username"
                                                placeholder="Username"
                                                value={vpnDetails.get(1)?.[0] ?? ''}
                                                onChange={(e) => handleVPNChange(e, 1)}
                                              />
                                            </Col>
                                            <Col className="col-6">
                                              <InputGroup>
                                                <Form.Control
                                                  id="pword1"
                                                  name="password"
                                                  type={maskStates[0] ? 'password' : 'text'}
                                                  placeholder="Enter IKEv2 Password"
                                                  value={vpnDetails.get(1)?.[1] ?? ''}
                                                  onChange={(e) => handleVPNChange(e, 1)}
                                                  disabled={isLoading}
                                                />
                                                <InputGroup.Text
                                                  id="apikeyinput"
                                                  style={{ cursor: 'pointer' }}
                                                  onClick={() => toggleMaskState(0)}
                                                >
                                                  {maskStates[0] ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                                </InputGroup.Text>
                                              </InputGroup>
                                            </Col>
                                          </Row>

                                          {/* Row 2 */}
                                          <Row className="mt-3">
                                            <Col className="col-6">
                                              <Form.Control
                                                id="uname2"
                                                type="text"
                                                name="username"
                                                placeholder="Username"
                                                value={vpnDetails.get(2)?.[0] ?? ''}
                                                onChange={(e) => handleVPNChange(e, 2)}
                                              />
                                            </Col>
                                            <Col className="col-6">
                                              <InputGroup>
                                                <Form.Control
                                                  id="pword2"
                                                  name="password"
                                                  type={maskStates[1] ? 'password' : 'text'}
                                                  placeholder="Enter IKEv2 Password"
                                                  value={vpnDetails.get(2)?.[1] ?? ''}
                                                  onChange={(e) => handleVPNChange(e, 2)}
                                                  disabled={isLoading}
                                                />
                                                <InputGroup.Text
                                                  id="apikeyinput"
                                                  style={{ cursor: 'pointer' }}
                                                  onClick={() => toggleMaskState(1)}
                                                >
                                                  {maskStates[1] ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                                </InputGroup.Text>
                                              </InputGroup>
                                            </Col>
                                          </Row>

                                          {/* Row 3 */}
                                          <Row className="mt-3">
                                            <Col className="col-6">
                                              <Form.Control
                                                id="uname3"
                                                type="text"
                                                name="username"
                                                placeholder="Username"
                                                value={vpnDetails.get(3)?.[0] ?? ''}
                                                onChange={(e) => handleVPNChange(e, 3)}
                                              />
                                            </Col>
                                            <Col className="col-6">
                                              <InputGroup>
                                                <Form.Control
                                                  id="pword3"
                                                  name="password"
                                                  type={maskStates[2] ? 'password' : 'text'}
                                                  placeholder="Enter IKEv2 Password"
                                                  value={vpnDetails.get(3)?.[1] ?? ''}
                                                  onChange={(e) => handleVPNChange(e, 3)}
                                                  disabled={isLoading}
                                                />
                                                <InputGroup.Text
                                                  id="apikeyinput"
                                                  style={{ cursor: 'pointer' }}
                                                  onClick={() => toggleMaskState(2)}
                                                >
                                                  {maskStates[2] ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                                </InputGroup.Text>
                                              </InputGroup>
                                            </Col>
                                          </Row>

                                          {/* Row 4 */}
                                          <Row className="mt-3">
                                            <Col className="col-6">
                                              <Form.Control
                                                id="uname4"
                                                type="text"
                                                name="username"
                                                placeholder="Username"
                                                value={vpnDetails.get(4)?.[0] ?? ''}
                                                onChange={(e) => handleVPNChange(e, 4)}
                                              />
                                            </Col>
                                            <Col className="col-6">
                                              <InputGroup>
                                                <Form.Control
                                                  id="pword4"
                                                  name="password"
                                                  type={maskStates[3] ? 'password' : 'text'}
                                                  placeholder="Enter IKEv2 Password"
                                                  value={vpnDetails.get(4)?.[1] ?? ''}
                                                  onChange={(e) => handleVPNChange(e, 4)}
                                                  disabled={isLoading}
                                                />
                                                <InputGroup.Text
                                                  id="apikeyinput"
                                                  style={{ cursor: 'pointer' }}
                                                  onClick={() => toggleMaskState(3)}
                                                >
                                                  {maskStates[3] ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                                </InputGroup.Text>
                                              </InputGroup>
                                            </Col>
                                          </Row>

                                          {/* Row 5 */}
                                          <Row className="mt-3">
                                            <Col className="col-6">
                                              <Form.Control
                                                id="uname5"
                                                type="text"
                                                name="username"
                                                placeholder="Username"
                                                value={vpnDetails.get(5)?.[0] ?? ''}
                                                onChange={(e) => handleVPNChange(e, 5)}
                                              />
                                            </Col>
                                            <Col className="col-6">
                                              <InputGroup>
                                                <Form.Control
                                                  id="pword5"
                                                  name="password"
                                                  type={maskStates[4] ? 'password' : 'text'}
                                                  placeholder="Enter IKEv2 Password"
                                                  value={vpnDetails.get(5)?.[1] ?? ''}
                                                  onChange={(e) => handleVPNChange(e, 5)}
                                                  disabled={isLoading}
                                                />
                                                <InputGroup.Text
                                                  id="apikeyinput"
                                                  style={{ cursor: 'pointer' }}
                                                  onClick={() => toggleMaskState(4)}
                                                >
                                                  {maskStates[4] ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                                </InputGroup.Text>
                                              </InputGroup>
                                            </Col>
                                          </Row>

                                          {/* Row 6 */}
                                          <Row className="mt-3">
                                            <Col className="col-6">
                                              <Form.Control
                                                id="uname6"
                                                type="text"
                                                name="username"
                                                placeholder="Username"
                                                value={vpnDetails.get(6)?.[0] ?? ''}
                                                onChange={(e) => handleVPNChange(e, 6)}
                                              />
                                            </Col>
                                            <Col className="col-6">
                                              <InputGroup>
                                                <Form.Control
                                                  id="pword6"
                                                  name="password"
                                                  type={maskStates[5] ? 'password' : 'text'}
                                                  placeholder="Enter IKEv2 Password"
                                                  value={vpnDetails.get(6)?.[1] ?? ''}
                                                  onChange={(e) => handleVPNChange(e, 6)}
                                                  disabled={isLoading}
                                                />
                                                <InputGroup.Text
                                                  id="apikeyinput"
                                                  style={{ cursor: 'pointer' }}
                                                  onClick={() => toggleMaskState(5)}
                                                >
                                                  {maskStates[5] ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                                </InputGroup.Text>
                                              </InputGroup>
                                            </Col>
                                          </Row>
                                        </Form.Group>
                                      </Col>
                                    </Row>
                                    <Button variant="primary" type="submit" disabled={isLoading}>
                                      {isLoading ? 'Saving...' : 'Save Changes'}
                                    </Button>
                                  </Form>
                                </Container>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="admin.AdvancedSettings">
                      <div className="k-overflow-y-scroll" style={{ height: `${containerHeight}px` }}>
                        <Row>
                          <Col className="col-12 p-0 ">
                            <Row className="m-0 mt-2">
                              <Col className="col-12">
                                <Container className="mb-4 mx-0">
                                  <Form onSubmit={handleSuperSubmit}>
                                    <Row className="mb-3">
                                      <Col md={6}>
                                        <div className='mb-3'>
                                          <span className="p-0 txt-12 txt-light" >
                                            The advanced tab allows administrators to enable license restricted features on the platform. 
                                            Adjust system preferences, update your account limits and manage important settings to ensure the service meets your needs. 
                                            Please do not change the option below unless you have an understanding of the impact.
                                          </span>
                                        </div>

                                        <span className="p-0 txt-14 txt-weight-900">Platform Settings</span>
                                        <hr id="k-adm-dash-l6" className='k-border-top-black mt-0 mb-2'></hr>
                                        <Form.Group controlId="envrionment" className="mb-3">
                                          <Form.Label>
                                            <span className="p-0 txt-12 txt-weight-500">Platform Type</span><span className="p-0 txt-12 txt-weight-200"> - platform should be set to Production unless being debugged</span>
                                          </Form.Label>

                                          <Dropdown>
                                            <Dropdown.Toggle variant="secondary" id="environment-dropdown" className='k-bg-trans color-DA k-p-8 k-wh-100pc k-dropdown-toggle'>
                                              {settings.ENVIRONMENT || 'Select your platform type'}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                              <Dropdown.Item
                                                eventKey="PRODUCTION"
                                                onClick={() => handleEnvironmentDropdownChange('PRODUCTION')}
                                              >
                                                Production
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                eventKey="DEVELOPMENT"
                                                onClick={() => handleEnvironmentDropdownChange('DEVELOPMENT')}
                                              >
                                                Development
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </Form.Group>

                                        <Form.Group controlId="support" className="mb-3">
                                          <Form.Label>
                                            <span className="p-0 txt-12 txt-weight-500">Support</span><span className="p-0 txt-12 txt-weight-200"> - select the support type for this platform</span>
                                          </Form.Label>

                                          <Dropdown>
                                            <Dropdown.Toggle variant="secondary" id="support-dropdown" className='k-bg-trans color-DA k-p-8 k-wh-100pc k-dropdown-toggle'>
                                              {settings.SUPPORT || 'Select the support package'}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                              <Dropdown.Item
                                                eventKey="ZENDESK"
                                                onClick={() => handleSupportDropdownChange('ZENDESK')}
                                              >
                                                ZenDesk
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                eventKey="NONE"
                                                onClick={() => handleSupportDropdownChange('NONE')}
                                              >
                                                None
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </Form.Group>

                                        <span className="p-0 txt-14 txt-weight-900">Licensed Features</span>
                                        <hr id="k-adm-dash-l6" className='k-border-top-black mt-0 mb-2'></hr>
                                        
                                        <div>
                                          <span className="p-0 txt-12 txt-weight-500">Cloud Storage</span>
                                          <span className="p-0 txt-12 txt-weight-200"> - enable or disable cloud storage for all users</span>
                                        </div>
                                        <Form.Check 
                                          type="switch"
                                          id="fileExplorer"
                                          label="File Explorer"
                                          name="FILE_EXPLORER"
                                          checked={settings.FILE_EXPLORER}
                                          onChange={handleInputChange}
                                          className="mb-2"
                                        />

                                        <div>
                                          <span className="p-0 txt-12 txt-weight-500">Reference</span>
                                          <span className="p-0 txt-12 txt-weight-200"> - enable or disable the reference library </span>
                                        </div>
                                        <Form.Check 
                                          type="switch"
                                          id="reference"
                                          label="Reference"
                                          name="REFERENCE"
                                          checked={settings.REFERENCE}
                                          onChange={handleInputChange}
                                          className="mb-2"
                                        />

                                        <div>
                                          <span className="p-0 txt-12 txt-weight-500">VPN</span>
                                          <span className="p-0 txt-12 txt-weight-200"> - enable or disable the VPN feature </span>
                                        </div>
                                        <Form.Check 
                                          type="switch"
                                          id="vpn"
                                          label="VPN"
                                          name="VPN"
                                          checked={settings.VPN}
                                          onChange={handleInputChange}
                                          className="mb-2"
                                        />

                                        <div>
                                          <span className="p-0 txt-12 txt-weight-500">Kuro AI</span>
                                          <span className="p-0 txt-12 txt-weight-200"> - enable or disable the AI chatbot</span>
                                        </div>
                                        <Form.Check 
                                          type="switch"
                                          id="kai"
                                          label="KAI"
                                          name="KAI"
                                          checked={settings.KAI}
                                          onChange={handleInputChange}
                                          className="mb-2"
                                        />

                                        <div>
                                          <span className="p-0 txt-12 txt-weight-500">Virtual Numbers</span>
                                          <span className="p-0 txt-12 txt-weight-200"> - enable or disable the virtual number support</span>
                                        </div>
                                        <Form.Check 
                                          type="switch"
                                          id="vnum"
                                          label="Virtual Number"
                                          name="VNUMBER"
                                          checked={settings.VNUMBER}
                                          onChange={handleInputChange}
                                          className="mb-2"
                                        />
                                      </Col>
                                    </Row>
                                    <Button variant="primary" type="submit">
                                    Save Changes
                                    </Button>
                                  </Form>
                                </Container>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
                </Row>
              </Tab.Container>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}

export const AdminLicensingContentTab: React.FunctionComponent<any> = (props:any) => {
  const { 
    handleAddLicense,
    users, 
    licensing,
    setLicenseData,
    updateLicense,
    handleLicenseDelete,
    initialRole
  } = props;

  interface User {
    id: string;
    identifier: string;
    [key: string]: any; // keep other fields flexible
  }

  const gridRef = useRef(null);
  const canEdit = initialRole === variables.DEFAULT_USER_ROLES.SUPERADMINISTRATOR;

  // Lookup function
  const getUserIdByIdentifier = (ident: string): string | undefined => {
    const user = users.find((u: User) => u.identifier === ident);
    return user?.id;
  };


  const LogoRenderer: React.FC<ICellRendererParams> = (params) => (
    <>
      {params.value && (
        <img
          alt={`${params.value} Flag`}
          src={imageMap[params.value.toLowerCase()]}
          className="k-h-25 k-w-30"
        />
      )}
    </>
  );

  const onFilterTextBoxChanged = useCallback(() => {
    const input = document.getElementById('filter-text-box') as HTMLInputElement | null;
    if (input) {
      gridRef.current?.api.setGridOption('quickFilterText', input.value);
    }
  }, []);
  

  // Column definitions typed for Car
  const colDefs = useMemo<ColDef<any>[]>(() => {
    return [
      { field: 'licenseType', headerName: '', cellRenderer: LogoRenderer, cellClass: 'logoCell p-0 ps-1', minWidth: 40, maxWidth: 40, editable: false },
      { field: 'id', width: 150, editable: canEdit },
      {
        headerName: 'Status',
        field: 'status',
        cellEditor: 'agSelectCellEditor',
        cellEditorParams: {
          values: types.licenseStatus,
        },
        width: 120,
        editable: canEdit
      },
      { field: 'reference', editable: canEdit, width: 150 },
      { field: 'purchaseDate', editable: canEdit, cellDataType: 'dateString', width: 150 },
      { field: 'renewalDate', editable: canEdit, cellDataType: 'dateString', width: 150 },
      { 
        headerName: 'Email',
        field: 'userEmail', 
        cellEditor: 'agSelectCellEditor',
        cellEditorParams: () => ({
          values: users?.map((u: User) => u.identifier) || [],
        }),
        editable: canEdit 
      },
      { field: 'userBU', editable: canEdit, width: 150 },
      {
        headerName: 'License Type',
        field: 'licenseType',
        cellEditor: 'agSelectCellEditor',
        cellEditorParams: {
          values: types.licenseTypes,
        },
        editable: canEdit,
        width: 150
      },
      { 
        field: 'licenseTypeValue', 
        headerName: 'License Notes',
        cellEditor: 'agLargeTextCellEditor',
        cellEditorPopup: true,
        cellEditorParams: { maxLength: 500 },
        editable: canEdit
      },
      {
        headerName: '',
        field: 'actions',
        cellRenderer: (params: ICellRendererParams) => {
          return (
            <FontAwesomeIcon
              className={`color-MA ${canEdit ? 'k-pointer' : 'disabled'}`}
              onClick={canEdit ? () => handleLicenseDelete(params.data) : undefined}
              icon={faTrash}
            />
          );
        },
        width: 50,
        editable: false
      }
    ];
  }, [handleLicenseDelete, users, canEdit]);

  const [containerHeight, setContainerHeight] = useState<number>(400); // Default height

  // Function to update the container height based on window size
  const updateHeight = () => {
    const windowHeight = window.innerHeight;
    const newHeight = windowHeight - 250; // Minus the top and bottom banners etc...
    setContainerHeight(newHeight);
  };

  const getRowClass = (params: RowClassParams<types.License>) => {
    if (!params.data?.renewalDate) return '';

    const today = new Date();
    const renewal = new Date(params.data.renewalDate); // parses '2025-02-12' correctly
    const twoMonthsFromNow = new Date();
    twoMonthsFromNow.setMonth(today.getMonth() + 2);

    if (renewal < today) {
      return 'license-row-expired'; // red background
    } else if (renewal <= twoMonthsFromNow) {
      return 'license-row-warning'; // yellow background
    }
    return '';
  };

  useEffect(() => {
    updateHeight(); // Set initial height
    window.addEventListener('resize', updateHeight);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);

  return (
    <>
      <Row className=''>
        <Col className='col-12'>
          <Row className='m-0'>
            <Col className="">
              <Row className='m-0 p-0'><Col className='m-0 p-0'> <span className='txt-17'>License Administration</span></Col></Row>
              <Row className='m-0 p-0'><Col className='m-0 p-0'> <span className='txt-12'>Create, Edit and delete Licensing for your organisation</span></Col></Row>
            </Col>
            <Col className="text-end k-center-content-hor-right-cen">
              <Button className="k-h-30 k-btn-submit-col txt-14 k-center-content" onClick={ canEdit ? () => { handleAddLicense(); } : undefined } disabled={!canEdit} type="submit" > Add License</Button>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className='mt-4'>
        <Col className='col-12'>
          <Row className='m-0'>
            <Col>
              <div className="example-header">
                <span>Filter table: </span>
                <input
                  type="text"
                  id="filter-text-box"
                  placeholder="Filter..."
                  onInput={onFilterTextBoxChanged}
                />
              </div>
            </Col>
          </Row>
        
          <Row className='m-0 mt-2'>
            <Col>
              <div style={{ height: containerHeight }}>
                <AgGridReact<types.License>
                  ref={gridRef}
                  rowData={licensing}
                  columnDefs={colDefs}
                  getRowClass={getRowClass}
                  onCellValueChanged={(params) => {
                    const updatedRow: types.License = { ...params.data };

                    if (updatedRow.userEmail) {
                      const mappedId = getUserIdByIdentifier(updatedRow.userEmail);
                      if (mappedId) {
                        updatedRow.userID = mappedId;
                      }
                    }

                    // Build payload with only the changed field + id
                    const changedField = params.colDef.field as keyof types.License;
                    const payload: Partial<types.License> & { id: string } = {
                      id: updatedRow.id,
                      ...(updatedRow.userID ? { userID: updatedRow.userID } : {}),
                      [changedField]: params.newValue
                    };

                    helpers.logToOutput(
                      `Changed field: ${changedField}, old: ${params.oldValue}, new: ${params.newValue}`
                    );

                    // Update local state so grid reflects change
                    setLicenseData((prev: types.License[]) => {
                      const index = prev.findIndex((l) => l.id === updatedRow.id);
                      if (index === -1) return prev;
                      const newData = [...prev];
                      newData[index] = updatedRow;
                      return newData;
                    });

                    // Send only changed field(s) to backend
                    updateLicense(payload as types.License);
                  }}
                />

              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </>

  );
}

export const UserSettingsTab: React.FC<any> = ( ) => {
  const authContext = useContext(authContextHelper.AuthContext);
  const isSignedIn = authContext.authStatus === authContextHelper.AuthStatus.SignedIn;
  

  const [userAttributes, setUserAttributes] = useState<types.IAccountUserAttributes>({
    identifier: authContext.userProfile['attributes']['identifier'],
    id: authContext.userProfile['attributes']['sub'],
    role: authContext.userProfile['role'],
  });

  const methods = useForm<types.IAccountInformationData>({
    defaultValues: {
      id: userAttributes.id,
      identifier: userAttributes.identifier,
      name: {
        first: userAttributes.firstName || '',
        last: userAttributes.lastName || '',
        middle: userAttributes.middleName || '',
      },
      display_name: userAttributes.displayName || '',
      phone: userAttributes.phone || '',
    },
  });

  const { reset } = methods;

  useEffect(() => {
    if (userAttributes) {
      reset({
        id: userAttributes.id,
        identifier: userAttributes.identifier,
        name: {
          first: userAttributes.firstName || '',
          last: userAttributes.lastName || '',
          middle: userAttributes.middleName || '',
        },
        display_name: userAttributes.displayName || '',
        phone: userAttributes.phone || '',
      });
    }
  }, [userAttributes, reset]);

  const getUserAttributes = useCallback(async () => {
    if (isSignedIn) {
      const sub = authContext?.userProfile?.attributes?.sub;

      const userAttributesResponse = await api.getUserAttributes({
        body: { id: sub },
      });

      if (userAttributesResponse.status === variables.DEFAULT_API_RESULT.SUCCESS) {
        setUserAttributes({
          id: userAttributesResponse.body.id,
          identifier: userAttributes.identifier,
          role: authContext.userProfile['role'],
          firstName: userAttributesResponse.body.name.first || '',
          lastName: userAttributesResponse.body.name.last || '',
          middleName: userAttributesResponse.body.name.middle || '',
          displayName: userAttributesResponse.body.display_name || '',
          phone: userAttributesResponse.body.phone || '',
        });
      } else {
        helpers.logToOutput('User Profile Attributes: Err: ', userAttributesResponse.errorMessage);
      }
    }
  }, [isSignedIn, authContext, setUserAttributes, userAttributes.identifier]);

  useEffect(() => {
    getUserAttributes();
  }, [getUserAttributes]);

  const handleUserAccountFormSubmit = async (body: types.IAccountInformationData) => {
    const userAtrributesPostResponse = await api.setUserAttributes({ body });

    if (userAtrributesPostResponse.status === variables.DEFAULT_API_RESULT.SUCCESS) {
      toast.success('User details have been updated');
    } else {
      toast.warn('Sorry your details weren\'t updated');
    }
  };

  const onSubmit: SubmitHandler<types.IAccountInformationData> = async (data) => {
    const payload: types.IAccountInformationData = {
      id: userAttributes.id,
      identifier: userAttributes.identifier,
      name: {
        first: data.name.first || '',
        last: data.name.last || '',
        middle: data.name.middle || '',
      },
      phone: data.phone || '',
      display_name: data.display_name || '',
    };
    await handleUserAccountFormSubmit(payload);
  };

  

  return (
    <FormProvider {...methods}>
      <Row className="">
        <Col className="col-12">
          <Row className="m-0">
            <Col className="">
              <Row className="m-0 p-0">
                <Col className="m-0 p-0">
                  <span className="txt-17">Account Settings</span>
                </Col>
              </Row>
              <Row className="m-0 p-0">
                <Col className="m-0 p-0">
                  <span className="txt-12">View and modify your account settings</span>
                </Col>
              </Row>
            </Col>
            <Col className="text-end k-center-content-hor-right-cen">
              <Button
                className="k-h-30 k-btn-submit-col txt-14 k-center-content"
                type="submit"
                onClick={methods.handleSubmit(onSubmit)}
              >
                Update
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="mt-2">
        <Col lg={12} className="ps-0">
          <Card className="b-shadow-off">
            <Card.Body>
              <Row className="mx-auto">
                <Col xs={8} className="ps-0">
                  <AccountInformation
                    userAttributes={userAttributes}
                    handleUserAccountFormSubmit={handleUserAccountFormSubmit}
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </FormProvider>
  );
};
